{
  "account.account": "Perfil i seguretat",
  "account.accountDeleted": "El vostre compte s'ha eliminat correctament.",
  "account.accountDescription": "Nom, contrasenya, elimina el compte",
  "account.accountSection": "Compte",
  "account.changeEmail": "Canvia el correu electrònic",
  "account.changePassword": "Canvia la contrasenya",
  "account.currentPassword": "Contrasenya actual",
  "account.dangerZone": "Zona de risc",
  "account.deleteAccount": "Elimina el vostre compte",
  "account.deleteAccountConfirmation": "Segur que voleu eliminar el vostre compte? Aquesta acció és irreversible.",
  "account.deleteAccountDescription": "Aquesta acció elimina el vostre compte i tota la vostra informació. No es pot desfer.",
  "account.emailChange": "Canvia l'adreça de correu electrònic",
  "account.emailChangeConfirmation": "Confirmació del canvi de correu electrònic",
  "account.emailChangeFailure": "L'enllaç de canvi de correu electrònic no és vàlid o ha caducat.",
  "account.emailChangeIntro": "Introduïu la vostra nova adreça de correu electrònic i la contrasenya actual. Enviarem un enllaç a la nova adreça: el correu electrònic només canviarà quan l'obriu.",
  "account.emailChangeSuccess": "El vostre correu electrònic s'ha canviat correctament a {newEmail}.",
  "account.emailChangeSuccessNoAddress": "La vostra adreça de correu electrònic s'ha canviat correctament.",
  "account.emailChangeVerificationSent": "S'ha enviat un correu electrònic de verificació a la vostra nova adreça de correu electrònic. Comproveu la safata d'entrada i feu clic a l'enllaç per confirmar el canvi.",
  "account.manageAccount": "Gestiona el compte",
  "account.newEmailAddress": "Nova adreça de correu electrònic",
  "account.newPassword": "Nova contrasenya",
  "account.newPasswordAgain": "Repetiu la nova contrasenya",
  "account.oldPassword": "Contrasenya antiga",
  "account.passwordChange": "Canvi de contrasenya",
  "account.passwordChangeDescription": "Mantén el teu compte segur",
  "account.passwordUpdated": "S'ha actualitzat la contrasenya correctament.",
  "account.profile": "Perfil",
  "account.profileUpdated": "S'ha actualitzat el perfil correctament.",
  "account.signedInAs": "Sessió iniciada com a",
  "account.updateYourProfile": "Actualitzeu el vostre perfil",
  "account.updateYourProfileDescription": "Nom i preferències de visualització",
  "addons.accountOnHold": "La connexió del vostre compte ha caducat. Torneu a connectar-vos per reprendre les actualitzacions de dades.",
  "addons.accountOnHoldTitle": "Compte en pausa",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Creeu i obteniu la vostra clau API des d'aquest enllaç",
  "addons.ambientWeatherDescription": "Estacions Ambient Weather (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "Clau API",
  "addons.applicationKey": "Clau d'aplicació",
  "addons.availableServices": "Disponibles",
  "addons.cannotDisconnectLastAccount": "No es pot desconnectar l'únic mètode d'inici de sessió. Afegiu primer un altre mètode d'inici de sessió.",
  "addons.connect": "Connecta",
  "addons.connected": "Connectat",
  "addons.connectedAccounts": "Comptes connectats",
  "addons.connectedAccountsDescription": "Apple, Google, Facebook",
  "addons.connectedServices": "Connectats",
  "addons.connectedSince": "Connectat des del {date}",
  "addons.connectionSection": "Connexió",
  "addons.connectionSuccess": "El compte de {provider} s'ha connectat correctament",
  "addons.davisApiSecret": "Secret API",
  "addons.davisApiV2Key": "Clau API V2",
  "addons.davisDescription": "Estacions meteorològiques Davis (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Obteniu les vostres claus API V2 des d'aquest enllaç",
  "addons.disconnect": "Desconnecta",
  "addons.disconnectConfirmation": "Segur que voleu desconnectar el vostre compte de {provider}?",
  "addons.disconnectionSuccess": "El compte de {provider} s'ha desconnectat correctament",
  "addons.disconnectProviderDescription": "Atura la sincronització. L'historial es conserva.",
  "addons.ecowittCreateAndRetrieveKeys": "Creeu i obteniu una clau API i una clau d'aplicació des d'aquest enllaç",
  "addons.ecowittDescription": "Ecowitt ofereix estacions meteorològiques wifi professionals, termòmetres sense fil per a interior i exterior, monitors d'humitat, pluviòmetres d'alta precisió, monitors de qualitat de l'aire i molt més.",
  "addons.helpLink": "Com connectar {provider}",
  "addons.integrationsSection": "Integracions",
  "addons.myAcuriteAccountOnHold": "El vostre compte s'ha posat en espera. Introduïu la vostra contrasenya per tornar a connectar el compte",
  "addons.myAcuriteDescription": "AcuRite és la marca d'estacions meteorològiques número 1 a Amèrica del Nord. Com a líder en tecnologia de temps, temperatura i meteorologia, AcuRite us proporciona informació detallada sobre el vostre entorn interior i exterior perquè pugueu planificar el vostre dia amb confiança.",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Utilitzeu el vostre termòstat Netatmo per canviar la temperatura de casa vostra, des del llit o des de l'altra punta del món.",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "La vostra estació meteorològica personal a casa",
  "addons.notConnected": "No connectat",
  "addons.or": "o",
  "addons.providerAccountDisconnected": "La connexió amb el vostre servei meteorològic ha caducat. Torneu a connectar-vos per reprendre les actualitzacions de dades.",
  "addons.reconnect": "Torna a connectar",
  "addons.socialConnectionsIntro": "Vinculeu els vostres comptes socials per activar l'inici de sessió ràpid. Podeu connectar o desconnectar comptes en qualsevol moment.",
  "addons.weatherflowCreateToken": "Creeu i obteniu el vostre testimoni des d'aquest enllaç",
  "addons.weatherflowTempestDescription": "Sistema meteorològic Tempest amb anemòmetre i pluviòmetre integrats",
  "addons.weatherServices": "Serveis meteorològics",
  "addons.weatherServicesConnected": "{count, plural, =0 {Cap servei connectat} one {# servei connectat} other {# serveis connectats}}",
  "addons.weatherServicesDescription": "Connecteu Netatmo, Davis, Weatherflow i més",
  "addons.wundergroundApiKey": "Clau API",
  "addons.wundergroundDescription": "Weather Underground és una comunitat global de persones que connecten dades de sensors ambientals com estacions meteorològiques i monitors de qualitat de l'aire perquè puguem oferir les dades riques i hiperlocals que necessiteu per alimentar les vostres passions",
  "addons.wundergroundRetrieveApiKey": "Obteniu la vostra clau API des d'aquest enllaç",
  "addons.wundergroundStationId": "Identificador de l'estació",
  "airQuality.adviceActivityGood": "Un dia ideal per a activitats a l'aire lliure",
  "airQuality.adviceActivityHazardous": "Eviteu qualsevol activitat física a l'aire lliure",
  "airQuality.adviceActivityLabel": "Activitat física",
  "airQuality.adviceActivityModerate": "Un bon dia per a activitats a l'aire lliure",
  "airQuality.adviceActivitySensitive": "Considereu activitats a l'aire lliure més curtes i menys intenses",
  "airQuality.adviceActivityUnhealthy": "Reduïu les activitats llargues o intenses i feu més pauses",
  "airQuality.adviceActivityVeryUnhealthy": "Eviteu les activitats llargues o intenses; considereu traslladar-les a l'interior",
  "airQuality.adviceGroupsGood": "No calen precaucions especials",
  "airQuality.adviceGroupsHazardous": "Quedeu-vos a l'interior i limiteu l'activitat",
  "airQuality.adviceGroupsLabel": "Grups sensibles",
  "airQuality.adviceGroupsModerate": "Persones especialment sensibles: activitats més curtes i menys intenses",
  "airQuality.adviceGroupsSensitive": "Activitats a l'aire lliure més curtes i menys intenses, i més pauses",
  "airQuality.adviceGroupsUnhealthy": "Eviteu activitats llargues o intenses a l'aire lliure; considereu fer-les a l'interior",
  "airQuality.adviceGroupsVeryUnhealthy": "Eviteu qualsevol activitat física a l'aire lliure; ajorneu-la o traslladeu-la a l'interior",
  "airQuality.adviceTimingLabel": "Quan sortir",
  "airQuality.adviceTimingMorning": "Millor al matí: l'ozó és més baix",
  "airQuality.airQuality": "Qualitat de l'aire",
  "airQuality.airQualityIndex": "Índex de qualitat de l'aire",
  "airQuality.aqiForecast": "Previsió de l'AQI",
  "airQuality.co2Fresh": "Fresc",
  "airQuality.co2GettingStale": "Una mica carregat",
  "airQuality.co2Stale": "Carregat",
  "airQuality.dailyForecast": "Previsió diària",
  "airQuality.dominantPollutant": "Contaminant dominant",
  "airQuality.expectedPeak": "Pic previst",
  "airQuality.good": "Bona",
  "airQuality.goodDescription": "La qualitat de l'aire es considera satisfactòria i la contaminació atmosfèrica presenta poc o cap risc",
  "airQuality.hazardous": "Perillosa",
  "airQuality.hazardousDescription": "Alerta sanitària: tothom pot experimentar efectes més greus per a la salut",
  "airQuality.indoorAirQuality": "Qualitat de l'aire interior",
  "airQuality.moderate": "Moderada",
  "airQuality.moderateDescription": "La qualitat de l'aire és acceptable; tanmateix, per a alguns contaminants pot haver-hi una preocupació sanitària moderada per a un nombre molt reduït de persones especialment sensibles a la contaminació atmosfèrica.",
  "airQuality.noForecastForLocation": "No hi ha previsió de qualitat de l'aire per a aquesta ubicació.",
  "airQuality.now": "Ara",
  "airQuality.nowCastAqi": "NowCast AQI",
  "airQuality.pollutants": "Contaminants",
  "airQuality.recommendations": "Recomanacions",
  "airQuality.sensitiveUnhealthy": "Perjudicial per a grups sensibles",
  "airQuality.sensitiveUnhealthyDescription": "Els membres dels grups sensibles poden experimentar efectes per a la salut. És poc probable que el públic general es vegi afectat.",
  "airQuality.subIndex": "Subíndex AQI",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "Entendre l'índex",
  "airQuality.unhealthy": "Perjudicial",
  "airQuality.unhealthyDescription": "Tothom pot començar a experimentar efectes per a la salut; els membres dels grups sensibles poden experimentar efectes més greus",
  "airQuality.veryUnhealthy": "Molt perjudicial",
  "airQuality.veryUnhealthyDescription": "Advertiments sanitaris de condicions d'emergència. És més probable que tota la població es vegi afectada.",
  "alerts.addAlert": "Afegeix una alerta",
  "alerts.addCondition": "Afegeix una condició",
  "alerts.alertAdded": "Alerta afegida correctament",
  "alerts.alertAuthorizationNotice": "Les alertes només funcionen si autoritzeu SmartMixin a mostrar notificacions",
  "alerts.alertDeleted": "Alerta eliminada correctament",
  "alerts.alertName": "Nom de l'alerta",
  "alerts.alertWhen": "Vull rebre una alerta quan:",
  "alerts.aqiGreaterThan": "AQI superior a",
  "alerts.aqiGreaterThanThreshold": "AQI superior al llindar de {value}{unit}",
  "alerts.aqiLessThan": "AQI inferior a",
  "alerts.aqiLessThanThreshold": "AQI inferior al llindar de {value}{unit}",
  "alerts.atLeastOneCondition": "Cal afegir almenys una condició",
  "alerts.co2GreaterThan": "CO2 superior a",
  "alerts.co2GreaterThanThreshold": "CO2 superior al llindar de {value}{unit}",
  "alerts.co2LessThan": "CO2 inferior a",
  "alerts.co2LessThanThreshold": "CO2 inferior al llindar de {value}{unit}",
  "alerts.conditions": "Condicions",
  "alerts.conditionsDroppedOnStationChange": "No compatibles amb aquesta estació i eliminades: {conditions}",
  "alerts.createAlert": "Crea una alerta",
  "alerts.dailyPrecipitationGreaterThan": "Precipitació diària superior a",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Precipitació diària superior al llindar de {value}{unit}",
  "alerts.deleteAlert": "Elimina l'alerta",
  "alerts.editAlert": "Edita l'alerta",
  "alerts.editCondition": "Edita la condició",
  "alerts.gustSpeedGreaterThan": "Velocitat de ràfega superior a",
  "alerts.gustSpeedGreaterThanThreshold": "Velocitat de ràfega superior al llindar de {value}{unit}",
  "alerts.gustSpeedLessThan": "Velocitat de ràfega inferior a",
  "alerts.gustSpeedLessThanThreshold": "Velocitat de ràfega inferior al llindar de {value}{unit}",
  "alerts.heatIndexGreaterThan": "Índex de calor superior a",
  "alerts.heatIndexGreaterThanThreshold": "Índex de calor superior al llindar de {value}{unit}",
  "alerts.heatIndexLessThan": "Índex de calor inferior a",
  "alerts.heatIndexLessThanThreshold": "Índex de calor inferior al llindar de {value}{unit}",
  "alerts.humidexGreaterThan": "Humidex superior a",
  "alerts.humidexGreaterThanThreshold": "Humidex superior al llindar de {value}{unit}",
  "alerts.humidexLessThan": "Humidex inferior a",
  "alerts.humidexLessThanThreshold": "Humidex inferior al llindar de {value}{unit}",
  "alerts.humidityGreaterThan": "Humitat superior a",
  "alerts.humidityGreaterThanThreshold": "Humitat superior al llindar de {value}{unit}",
  "alerts.humidityLessThan": "Humitat inferior a",
  "alerts.humidityLessThanThreshold": "Humitat inferior al llindar de {value}{unit}",
  "alerts.inProgress": "En curs",
  "alerts.leafWetnessGreaterThan": "Humectació foliar superior a",
  "alerts.leafWetnessGreaterThanThreshold": "Humectació foliar superior al llindar de {value}{unit}",
  "alerts.leafWetnessLessThan": "Humectació foliar inferior a",
  "alerts.leafWetnessLessThanThreshold": "Humectació foliar inferior al llindar de {value}{unit}",
  "alerts.myAlerts": "Les meves alertes",
  "alerts.noConfiguredAlert": "Encara no teniu cap alerta configurada, comenceu a afegir-ne una",
  "alerts.noiseGreaterThan": "Soroll superior a",
  "alerts.noiseGreaterThanThreshold": "Soroll superior al llindar de {value}{unit}",
  "alerts.noiseLessThan": "Soroll inferior a",
  "alerts.noiseLessThanThreshold": "Soroll inferior al llindar de {value}{unit}",
  "alerts.noteOnConditions": "Tingueu en compte que l'alerta s'activa quan es compleixen totes les condicions següents",
  "alerts.noTriggerHistory": "Aquesta alerta encara no s'ha activat.",
  "alerts.pm10GreaterThan": "PM 10 superior a",
  "alerts.pm10GreaterThanThreshold": "PM 10 superior al llindar de {value}{unit}",
  "alerts.pm10LessThan": "PM 10 inferior a",
  "alerts.pm10LessThanThreshold": "PM 10 inferior al llindar de {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 superior a",
  "alerts.pm1GreaterThanThreshold": "PM 1 superior al llindar de {value}{unit}",
  "alerts.pm1LessThan": "PM 1 inferior a",
  "alerts.pm1LessThanThreshold": "PM 1 inferior al llindar de {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2.5 superior a",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5 superior al llindar de {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2.5 inferior a",
  "alerts.pm2p5LessThanThreshold": "PM 2.5 inferior al llindar de {value}{unit}",
  "alerts.postStormSummary": "Resum posterior a la tempesta",
  "alerts.postStormSynopsisHelper": "Rebreu una notificació de resum després que acabi cada tempesta de pluja.",
  "alerts.postStormSynopsisSoleCondition": "Un resum posterior a la tempesta no es pot combinar amb altres condicions.",
  "alerts.precipitationGreaterThan": "Precipitació horària superior a",
  "alerts.precipitationGreaterThanThreshold": "Precipitació horària superior al llindar de {value}{unit}",
  "alerts.pressureGreaterThan": "Pressió superior a",
  "alerts.pressureGreaterThanThreshold": "Pressió superior al llindar de {value}{unit}",
  "alerts.pressureLessThan": "Pressió inferior a",
  "alerts.pressureLessThanThreshold": "Pressió inferior al llindar de {value}{unit}",
  "alerts.rainRateGreaterThan": "Intensitat de pluja superior a",
  "alerts.rainRateGreaterThanThreshold": "Intensitat de pluja superior al llindar de {value}{unit}",
  "alerts.sensorNotReporting": "Aquest sensor no envia dades ara mateix. L'alerta es reprendrà quan torni a fer-ho.",
  "alerts.soilMoistureGreaterThan": "Humitat del sòl superior a",
  "alerts.soilMoistureGreaterThanThreshold": "Humitat del sòl superior al llindar de {value}{unit}",
  "alerts.soilMoistureLessThan": "Humitat del sòl inferior a",
  "alerts.soilMoistureLessThanThreshold": "Humitat del sòl inferior al llindar de {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Radiació solar superior a",
  "alerts.solarRadiationGreaterThanThreshold": "Radiació solar superior al llindar de {value}{unit}",
  "alerts.solarRadiationLessThan": "Radiació solar inferior a",
  "alerts.solarRadiationLessThanThreshold": "Radiació solar inferior al llindar de {value}{unit}",
  "alerts.stormChartUnavailable": "L'historial de pluja d'aquesta tempesta no està disponible.",
  "alerts.stormDetail": "Resum de la tempesta",
  "alerts.stormDuration": "Durada",
  "alerts.stormEnd": "Fi",
  "alerts.stormPeakRate": "Intensitat màxima de pluja",
  "alerts.stormStart": "Inici",
  "alerts.stormTotal": "Pluja total",
  "alerts.temperatureGreaterThan": "Temperatura superior a",
  "alerts.temperatureGreaterThanThreshold": "Temperatura superior al llindar de {value}{unit}",
  "alerts.temperatureLessThan": "Temperatura inferior a",
  "alerts.temperatureLessThanThreshold": "Temperatura inferior al llindar de {value}{unit}",
  "alerts.thresholdOutOfRange": "Ha d'estar entre {min} i {max}",
  "alerts.thswGreaterThan": "THSW superior a",
  "alerts.thswGreaterThanThreshold": "THSW superior al llindar de {value}{unit}",
  "alerts.thswLessThan": "THSW inferior a",
  "alerts.thswLessThanThreshold": "THSW inferior al llindar de {value}{unit}",
  "alerts.thwGreaterThan": "THW superior a",
  "alerts.thwGreaterThanThreshold": "THW superior al llindar de {value}{unit}",
  "alerts.thwLessThan": "THW inferior a",
  "alerts.thwLessThanThreshold": "THW inferior al llindar de {value}{unit}",
  "alerts.triggerHistory": "Historial de l'alerta",
  "alerts.uvGreaterThan": "Índex UV superior a",
  "alerts.uvGreaterThanThreshold": "Índex UV superior al llindar de {value}{unit}",
  "alerts.uvLessThan": "Índex UV inferior a",
  "alerts.uvLessThanThreshold": "Índex UV inferior al llindar de {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Visibilitat superior al llindar de {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Visibilitat inferior al llindar de {value}{unit}",
  "alerts.visiblityGreaterThan": "Visibilitat superior a",
  "alerts.visiblityLessThan": "Visibilitat inferior a",
  "alerts.whichMeasure": "Per a quina mesura voleu rebre alertes?",
  "alerts.whichModule": "Per a quin mòdul voleu rebre alertes?",
  "alerts.whichSensor": "Per a quin sensor voleu rebre alertes?",
  "alerts.windChillGreaterThan": "Sensació de fred superior a",
  "alerts.windChillGreaterThanThreshold": "Sensació de fred superior al llindar de {value}{unit}",
  "alerts.windChillLessThan": "Sensació de fred inferior a",
  "alerts.windChillLessThanThreshold": "Sensació de fred inferior al llindar de {value}{unit}",
  "alerts.windSpeedGreaterThan": "Velocitat del vent superior a",
  "alerts.windSpeedGreaterThanThreshold": "Velocitat del vent superior al llindar de {value}{unit}",
  "alerts.windSpeedLessThan": "Velocitat del vent inferior a",
  "alerts.windSpeedLessThanThreshold": "Velocitat del vent inferior al llindar de {value}{unit}",
  "appUpdate.updateAvailable": "Actualització disponible",
  "appUpdate.updateAvailableOpenAppStore": "Toqueu per obrir l'App Store",
  "appUpdate.updateAvailableOpenGooglePlay": "Toqueu per obrir Google Play",
  "appUpdate.updateAvailableVersion": "Actualització disponible: v{version}",
  "appUpdate.upgradeRequiredAndroid": "Cal actualitzar la vostra aplicació. Visiteu Google Play per actualitzar-la.",
  "appUpdate.upgradeRequiredIos": "Cal actualitzar la vostra aplicació. Visiteu l'App Store per actualitzar-la.",
  "astral.aboveHorizonAllDay": "Sobre l’horitzó tot el dia",
  "astral.aboveTheHorizon": "sobre l’horitzó",
  "astral.apparentSize": "Diàmetre aparent",
  "astral.apparentSizeAcross": "{size} de diàmetre",
  "astral.astronomicalDawn": "Alba astronòmica",
  "astral.astronomicalDusk": "Crepuscle astronòmic",
  "astral.belowHorizonAllDay": "Sota l’horitzó tot el dia",
  "astral.belowHorizonSince": "Sota l’horitzó des de les {time}",
  "astral.belowHorizonSinceOn": "Sota l’horitzó des de {day} a les {time}",
  "astral.brightAllNight": "Lluna brillant tota la nit — mai del tot fosc",
  "astral.brightestMoment": "Moment més clar",
  "astral.civilDawn": "Alba civil",
  "astral.civilDusk": "Crepuscle civil",
  "astral.darkSkyBetween": "Cel fosc {from} → {to}",
  "astral.darkSkyWindow": "Cel fosc {from} → {to} · {duration} sense Lluna",
  "astral.dayLength": "Durada del dia",
  "astral.daylightThroughTheYear": "Durada del dia durant l’any",
  "astral.dayOfCycle": "dia {day} de {total}",
  "astral.doesNotOccurToday": "Avui no té lloc",
  "astral.domeHint": "Arrossega per recórrer la nit",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.earliestSunrise": "Sortida del sol més primerenca",
  "astral.earliestSunset": "Posta del sol més primerenca",
  "astral.equinox": "Equinocci",
  "astral.equinoxIn": "Equinocci d’aquí a {days, plural, one {# dia} other {# dies}}",
  "astral.evening": "Vespre",
  "astral.exactPhaseAt": "Exactament a les {time}",
  "astral.firstQuarter": "Quart creixent",
  "astral.firstSunriseIn": "Primera sortida del sol d’aquí a {days, plural, one {# dia} other {# dies}}",
  "astral.firstSunsetIn": "Primera posta de sol d’aquí a {days, plural, one {# dia} other {# dies}}",
  "astral.fullMoon": "Lluna plena",
  "astral.goldenHourBegins": "Comença l’hora daurada",
  "astral.goldenHourEnds": "Acaba l’hora daurada",
  "astral.highestPoint": "Punt més alt",
  "astral.inDays": "d’aquí a {days, plural, one {# dia} other {# dies}}",
  "astral.lastQuarter": "Quart minvant",
  "astral.latestSunrise": "Sortida del sol més tardana",
  "astral.latestSunset": "Posta del sol més tardana",
  "astral.litShort": "Il·lum.",
  "astral.longestDay": "Dia més llarg",
  "astral.lowestPoint": "Punt més baix",
  "astral.maxAltitudeShort": "Màx.",
  "astral.midday": "Migdia",
  "astral.midnightSun": "Sol de mitjanit",
  "astral.midnightSunPeriod": "Sol de mitjanit",
  "astral.milestoneFootnotePolar": "Aquí el sol no surt ni es pon durant {days, plural, one {# dia} other {# dies}} l’any, així que, en lloc dels extrems habituals de sortida i posta, la llista mostra quan passa això.",
  "astral.milestoneFootnoteTemperate": "La posta més primerenca i la sortida més tardana no cauen el dia més curt — és l’equació del temps, no el solstici, la que fixa aquestes dues dates.",
  "astral.moon": "Lluna",
  "astral.moonAltitude": "Altura",
  "astral.moonDirection": "Azimut",
  "astral.moonDistance": "Distància",
  "astral.moonlessFor": "{duration} sense Lluna",
  "astral.moonPhases": "Fases de la lluna",
  "astral.moonrise": "Sortida de la lluna",
  "astral.moonset": "Posta de la lluna",
  "astral.moonUpAllNight": "La Lluna és sobre l’horitzó tota la nit",
  "astral.moonWashesOutNight": "La Lluna és sobre l’horitzó de les {rise} a les {set} i il·lumina tota la nit",
  "astral.morning": "Matí",
  "astral.nauticalDawn": "Alba nàutica",
  "astral.nauticalDusk": "Crepuscle nàutic",
  "astral.newMoon": "Lluna nova",
  "astral.nextDay": "+1 dia",
  "astral.nextProperlyDarkNight": "Propera nit realment fosca",
  "astral.nextRise": "propera sortida a les {time}",
  "astral.nextRiseOn": "propera sortida {day} a les {time}",
  "astral.nextSevenNights": "Les set properes nits",
  "astral.noAstronomicalDarknessTonight": "Sense nit astronòmica aquesta nit",
  "astral.noDarkNightAhead": "Cap en les dues properes setmanes",
  "astral.noSunriseToday": "Avui el Sol no surt",
  "astral.nowAtBearing": "ara {altitude} · azimut {direction}",
  "astral.observing": "Observació",
  "astral.ofDaylightLeft": "de llum de dia restant",
  "astral.overTheNextThreeWeeks": "en les properes 3 setmanes",
  "astral.percentLit": "{percent} il·luminada",
  "astral.polarNight": "Nit polar",
  "astral.polarNightPeriod": "Nit polar",
  "astral.rightNow": "Ara mateix",
  "astral.riseShort": "Sortida",
  "astral.setShort": "Posta",
  "astral.shortestDay": "Dia més curt",
  "astral.solarNoon": "Migdia solar",
  "astral.solstice": "Solstici",
  "astral.sunBelowHorizon": "Sol a {degrees}° sota l’horitzó",
  "astral.sunEvents": "Esdeveniments solars",
  "astral.sunNeverDarkEnough": "El Sol mai baixa 18° sota l’horitzó",
  "astral.sunNeverSets": "El Sol no es pon",
  "astral.sunrise": "Sortida del sol",
  "astral.sunriseAndSunset": "Sortida i posta del sol",
  "astral.sunriseAt": "Sortida del sol a les {time}",
  "astral.sunset": "Posta del sol",
  "astral.sunsetAt": "Posta del sol a les {time}",
  "astral.thisYearAtNorth": "Enguany a {degrees}° N",
  "astral.thisYearAtSouth": "Enguany a {degrees}° S",
  "astral.tonight": "Aquesta nit",
  "astral.twilightAllNight": "Crepuscle tota la nit — mai del tot fosc",
  "astral.upFor": "{duration} sobre l’horitzó",
  "astral.usableLight": "Llum aprofitable",
  "astral.vsAverage": "{percent} respecte a la mitjana",
  "astral.vsYesterday": "respecte a ahir",
  "astral.waningCrescent": "Lluna minvant",
  "astral.waningGibbous": "Gibosa minvant",
  "astral.waxingCrescent": "Lluna creixent",
  "astral.waxingGibbous": "Gibosa creixent",
  "astral.whereToLook": "On mirar",
  "astral.withoutTheMoon": "{duration} sense Lluna",
  "auth.alreadyHaveAccount": "Ja teniu un compte?",
  "auth.authContainerTagline": "El vostre tauler meteorològic personal. Connecteu les vostres estacions i obteniu dades en temps real a l'abast dels dits.",
  "auth.backToLogin": "Torna a l'inici de sessió",
  "auth.checkYourEmail": "Reviseu el vostre correu electrònic",
  "auth.continueWithApple": "Continua amb Apple",
  "auth.continueWithFacebook": "Continua amb Facebook",
  "auth.continueWithGoogle": "Continua amb Google",
  "auth.email": "Adreça electrònica",
  "auth.emailRequiredLoginFacebook": "Cal el permís de correu electrònic.",
  "auth.emailVerification": "Verificació del correu electrònic",
  "auth.emailVerificationFailure": "S'ha produït un problema amb la verificació del vostre correu electrònic.",
  "auth.emailVerificationSuccess": "El vostre correu electrònic s'ha verificat correctament.",
  "auth.firstName": "Nom",
  "auth.forgotPassword": "Heu oblidat la contrasenya?",
  "auth.forgotPasswordSubtitle": "Introduïu el vostre correu electrònic i us enviarem un enllaç per restablir la contrasenya.",
  "auth.lastName": "Cognoms",
  "auth.login": "Inicia la sessió",
  "auth.loginSubtitle": "Ens alegrem de tornar-vos a veure! Introduïu les vostres dades.",
  "auth.loginToSmartMixinDescription": "Inicieu la sessió a SmartMixin per accedir a les vostres estacions meteorològiques, veure analítiques i gestionar el vostre tauler meteorològic personal.",
  "auth.logout": "Tanca la sessió",
  "auth.logoutConfirmation": "Voleu tancar la sessió?",
  "auth.noAccountYet": "Encara no teniu cap compte?",
  "auth.or": "o",
  "auth.password": "Contrasenya",
  "auth.passwordReset": "Restabliment de la contrasenya",
  "auth.passwordResetSuccess": "La vostra contrasenya s'ha actualitzat correctament.",
  "auth.register": "Crea un compte",
  "auth.registerDescription": "Creeu un compte gratuït de SmartMixin per connectar les vostres estacions meteorològiques, fer el seguiment de les dades del temps i accedir a potents eines d'analítica.",
  "auth.registerSubtitle": "Creeu el vostre compte per començar.",
  "auth.restorePassword": "Recupera la contrasenya",
  "auth.restorePasswordSuccess": "Us acabem d'enviar un enllaç per restablir la contrasenya a {emailAddress} amb més instruccions.",
  "auth.sendReset": "Envia les instruccions de restabliment",
  "auth.signInWithApple": "Inicia la sessió amb Apple",
  "auth.socialAccount": "o utilitzeu el vostre compte",
  "auth.staffVerificationCode": "Codi de verificació",
  "auth.staffVerificationExpiresIn": "Verificat. Caduca d'aquí a {duration}.",
  "auth.staffVerificationInvalidCode": "Codi incorrecte. Torneu-ho a provar.",
  "auth.staffVerificationLoginAsStopped": "S'ha aturat Login As: introduïu un codi de verificació a la pantalla Debug per continuar.",
  "auth.staffVerificationNotEnrolled": "No hi ha cap aplicació d'autenticació configurada per al vostre compte. Afegiu-ne una a la configuració de seguretat del back office.",
  "auth.staffVerificationPrompt": "Introduïu el codi de 6 xifres de la vostra aplicació d'autenticació, o un codi de recuperació, per utilitzar Login As i la cerca d'usuaris.",
  "auth.staffVerificationSetupLink": "Afegeix una aplicació d'autenticació",
  "auth.staffVerificationSubmit": "Verifica",
  "auth.staffVerificationTitle": "Verificació del personal",
  "calendar.afternoon": "Tarda",
  "calendar.april": "Abril",
  "calendar.august": "Agost",
  "calendar.changePeriod": "Període: {period}. Canvia el període",
  "calendar.currentDay": "Dia actual",
  "calendar.dateFormat": "Format de data",
  "calendar.day": "Dia",
  "calendar.december": "Desembre",
  "calendar.durationHours": "{hours} h",
  "calendar.durationHoursMinutes": "{hours} h {minutes} min",
  "calendar.durationMinutes": "{minutes} min",
  "calendar.durationMinutesSeconds": "{minutes} min {seconds} s",
  "calendar.durationSeconds": "{seconds} s",
  "calendar.endTime": "Hora de finalització",
  "calendar.evening": "Vespre",
  "calendar.february": "Febrer",
  "calendar.goToNextDay": "Dia següent",
  "calendar.goToNextMonth": "Mes següent",
  "calendar.goToNextWeek": "Setmana següent",
  "calendar.goToNextYear": "Any següent",
  "calendar.goToPreviousDay": "Dia anterior",
  "calendar.goToPreviousMonth": "Mes anterior",
  "calendar.goToPreviousWeek": "Setmana anterior",
  "calendar.goToPreviousYear": "Any anterior",
  "calendar.hour": "Hora",
  "calendar.hoursCount": "{count, plural, one {# hora} other {# hores}}",
  "calendar.hoursShort": "h",
  "calendar.hoursShortCount": "{count, plural, one {# h} other {# h}}",
  "calendar.january": "Gener",
  "calendar.july": "Juliol",
  "calendar.june": "Juny",
  "calendar.last12Hours": "Últimes 12 hores",
  "calendar.last24Hours": "Últimes 24 hores",
  "calendar.last30Days": "Últims 30 dies",
  "calendar.last3Hours": "Últimes 3 hores",
  "calendar.last6Hours": "Últimes 6 hores",
  "calendar.last7Days": "Últims 7 dies",
  "calendar.lastHour": "Última hora",
  "calendar.march": "Març",
  "calendar.max": "Màx",
  "calendar.may": "Maig",
  "calendar.month": "Mes",
  "calendar.monthTotal": "Total del mes",
  "calendar.morning": "Matí",
  "calendar.nextHours": "Pròximes hores",
  "calendar.night": "Nit",
  "calendar.november": "Novembre",
  "calendar.october": "Octubre",
  "calendar.oneDay": "1 dia",
  "calendar.oneHour": "1 hora",
  "calendar.oneMonth": "1 mes",
  "calendar.oneWeek": "1 setmana",
  "calendar.periodRangeSpoken": "del {start} al {end}",
  "calendar.previous24Hours": "24 hores anteriors",
  "calendar.previous30Days": "30 dies anteriors",
  "calendar.previous7Days": "7 dies anteriors",
  "calendar.previousDay": "Dia anterior",
  "calendar.previousHours": "Hores anteriors",
  "calendar.previousMonth": "Mes anterior",
  "calendar.previousWeek": "Setmana anterior",
  "calendar.previousYear": "Any anterior",
  "calendar.sameDayLastYear": "Mateix dia de l'any passat",
  "calendar.sameMonthLastYear": "Mateix mes de l'any passat",
  "calendar.selectADate": "Seleccioneu una data",
  "calendar.selectAggregation": "Seleccioneu el valor mostrat",
  "calendar.selectAMonth": "Seleccioneu un mes",
  "calendar.selectAYear": "Seleccioneu un any",
  "calendar.selectGranularity": "Seleccioneu una granularitat",
  "calendar.selectPeriod": "Seleccioneu un període",
  "calendar.september": "Setembre",
  "calendar.sixHours": "6 hores",
  "calendar.startTime": "Hora d'inici",
  "calendar.thirtyMinutes": "30 min",
  "calendar.threeHours": "3 hores",
  "calendar.timezone": "Fus horari",
  "calendar.today": "Avui",
  "calendar.untilChanged": "Fins que es canviï",
  "calendar.untilTime": "Fins a {time}",
  "calendar.untilTodayAt": "Fins avui a les {time}",
  "calendar.untilTomorrowAt": "Fins demà a les {time}",
  "calendar.use24HourFormat": "Utilitza el format de 24 hores",
  "calendar.week": "Setmana",
  "calendar.year": "Any",
  "calendar.yearToDate": "En el que va d'any",
  "calendar.yesterday": "Ahir",
  "charts.averageOverThePeriod": "Mitjana del període",
  "charts.calendarView": "Vista de calendari",
  "charts.charts": "Gràfics",
  "charts.chartView": "Vista de gràfic",
  "charts.comparison": "Comparació",
  "charts.customizeComparisonMetrics": "Personalitza les mètriques",
  "charts.customizeComparisonMetricsDescription": "Arrossegueu els elements per reordenar les mètriques de comparació. Toqueu la icona de l'ull per mostrar o amagar mètriques.",
  "charts.maxOverThePeriod": "Màxim del període",
  "charts.measureToDisplay": "Mesura a mostrar",
  "charts.minMaxRange": "Mín. / Màx.",
  "charts.noDataForThisPeriod": "No hi ha dades per a aquest període",
  "charts.observations": "Observacions",
  "charts.observedTemperature": "Temperatura observada",
  "charts.showComparison": "Mostra la comparació",
  "charts.stationComparison": "Comparació d'estacions",
  "charts.stationComparisonDescription": "Compareu dades meteorològiques històriques amb una altra estació",
  "charts.sumOverThePeriod": "Acumulat durant el període",
  "charts.viewAsList": "Llista",
  "charts.viewAsPeriods": "Períodes",
  "common.add": "Afegeix",
  "common.altitude": "Altitud",
  "common.analysis": "Anàlisi",
  "common.average": "Mitjana",
  "common.back": "Enrere",
  "common.backToHome": "Torna a l'inici",
  "common.cancel": "Cancel·la",
  "common.cannotBeEmpty": "Aquest camp no pot estar buit.",
  "common.close": "Tanca",
  "common.dailyForecast": "Previsió diària",
  "common.default": "Predeterminat",
  "common.delete": "Elimina",
  "common.details": "Detalls",
  "common.edit": "Edita",
  "common.exitFullscreen": "Surt de la pantalla completa",
  "common.forecast": "Previsió",
  "common.frequency": "Freqüència",
  "common.full": "Complet",
  "common.fullscreen": "Pantalla completa",
  "common.help": "Ajuda",
  "common.hidden": "Amagat",
  "common.high": "Alt",
  "common.iDontKnowYet": "Encara no ho sé",
  "common.indoor": "Interior",
  "common.labelValue": "{label}: {value}",
  "common.lastUpdate": "Última actualització",
  "common.low": "Baix",
  "common.maximum": "Màxim",
  "common.medium": "Mitjà",
  "common.minimum": "Mínim",
  "common.more": "Més",
  "common.moreInformation": "Més informació",
  "common.next": "Següent",
  "common.no": "No",
  "common.noAccountNeeded": "No cal cap compte",
  "common.noItemsAvailable": "No hi ha elements disponibles",
  "common.notNow": "Ara no",
  "common.now": "Ara",
  "common.openSettings": "Obre la configuració",
  "common.outdoor": "Exterior",
  "common.pageNotFound": "Pàgina no trobada",
  "common.pageNotFoundDescription": "La pàgina que cerqueu no existeix o s'ha mogut.",
  "common.rain": "Pluja",
  "common.share": "Comparteix",
  "common.shareImageFailed": "No s'ha pogut compartir la imatge",
  "common.shareYourWeather": "Comparteix el vostre temps",
  "common.skip": "Omet",
  "common.start": "Comença",
  "common.unknown": "Desconegut",
  "common.validate": "Confirma",
  "common.validEmail": "Cal una adreça de correu electrònic vàlida.",
  "common.very_low": "Molt baix",
  "common.weatherObservations": "Observacions meteorològiques",
  "common.welcome": "Us donem la benvinguda a SmartMixin!",
  "common.wind": "Vent",
  "common.yes": "Sí",
  "common.zoomImage": "Amplia la imatge",
  "compass.E": "E",
  "compass.E_long": "Est",
  "compass.ENE": "ENE",
  "compass.ENE_long": "Est-nord-est",
  "compass.ESE": "ESE",
  "compass.ESE_long": "Est-sud-est",
  "compass.N": "N",
  "compass.N_long": "Nord",
  "compass.NE": "NE",
  "compass.NE_long": "Nord-est",
  "compass.NNE": "NNE",
  "compass.NNE_long": "Nord-nord-est",
  "compass.NNW": "NNO",
  "compass.NNW_long": "Nord-nord-oest",
  "compass.NW": "NO",
  "compass.NW_long": "Nord-oest",
  "compass.S": "S",
  "compass.S_long": "Sud",
  "compass.SE": "SE",
  "compass.SE_long": "Sud-est",
  "compass.SSE": "SSE",
  "compass.SSE_long": "Sud-sud-est",
  "compass.SSW": "SSO",
  "compass.SSW_long": "Sud-sud-oest",
  "compass.SW": "SO",
  "compass.SW_long": "Sud-oest",
  "compass.W": "O",
  "compass.W_long": "Oest",
  "compass.WNW": "ONO",
  "compass.WNW_long": "Oest-nord-oest",
  "compass.WSW": "OSO",
  "compass.WSW_long": "Oest-sud-oest",
  "dashboard.currentObservations": "Observacions actuals",
  "dashboard.currentRainEvent": "Episodi de pluja actual",
  "dashboard.currentWeatherConditions": "Condicions actuals",
  "dashboard.customizeDashboard": "Personalitza",
  "dashboard.customizeDashboardDescription": "Arrossegueu els elements per reordenar el vostre tauler. Toqueu la icona de l'ull per mostrar o amagar seccions.",
  "dashboard.dashboard": "Tauler",
  "dashboard.dayRangeExpected": "{value} previst a les {time}",
  "dashboard.dayRangeReached": "{value} a les {time}",
  "dashboard.dayRangeSteady": "Estable a {value} tot el dia",
  "dashboard.hiddenSensors": "Sensors amagats",
  "dashboard.lastRainEvent": "Últim episodi de pluja",
  "dashboard.manageSensors": "Gestiona els sensors",
  "dashboard.manageSensorsDescription": "Arrossegueu els elements per reordenar els sensors. Toqueu la icona de l'ull per mostrar o amagar els sensors. Toqueu un nom per canviar-lo.",
  "dashboard.pressureSummary": "Resum de pressió",
  "dashboard.rainEvents": "Episodis de pluja",
  "dashboard.rainSummary": "Resum de pluja",
  "dashboard.shareOutdoorMeasures": "Comparteix les vostres mesures exteriors",
  "dashboard.shareOutdoorMeasuresDescription": "Participeu en la comunitat de SmartMixin fent visibles les vostres mesures exteriors als altres. Les mesures interiors mai no es compartiran.",
  "dashboard.temperatureSummary": "Resum de temperatura",
  "dashboard.windSummary": "Resum del vent",
  "devices.batteryLevel": "Nivell de bateria",
  "devices.firmwareVersion": "Versió del microprogramari",
  "devices.moduleCount": "{count, plural, one {# mòdul} other {# mòduls}}",
  "devices.moduleType": "Tipus de mòdul",
  "devices.noNetatmoWeatherStationYet": "Encara no teniu cap estació meteorològica Netatmo.",
  "devices.noOutdoorModule": "No hi ha cap mòdul exterior funcional per a aquesta estació.",
  "devices.notReachable": "Sense connexió",
  "devices.serialNumber": "Número de sèrie",
  "devices.signalAverage": "Mitjà",
  "devices.signalBad": "Feble",
  "devices.signalGood": "Bo",
  "devices.signalStrength": "Intensitat del senyal",
  "devices.signalUnknown": "Desconegut",
  "devices.visitNetatmoWebsite": "Visita el lloc web de Netatmo",
  "devices.wifiStrength": "Intensitat del Wi-Fi",
  "forecastMaps.addColor": "Afegeix color",
  "forecastMaps.addLayer": "Afegeix capa",
  "forecastMaps.autoPreview": "Auto",
  "forecastMaps.backToMaps": "Torna als mapes",
  "forecastMaps.build": "Genera",
  "forecastMaps.buildCompleted": "Generació completada",
  "forecastMaps.builderMetaDescription": "Componeu mapes de previsió personalitzats a partir de capes de models meteorològics.",
  "forecastMaps.builderTitle": "Constructor de mapes",
  "forecastMaps.buildFailed": "La generació ha fallat. Torneu-ho a provar.",
  "forecastMaps.buildNotPossible": "Aquest mapa encara no es pot generar: no hi ha dades de previsió disponibles.",
  "forecastMaps.buildProgress": "S'està renderitzant… {completed}/{total} passos",
  "forecastMaps.buildStarting": "S'està iniciant la generació…",
  "forecastMaps.byModel": "Per model",
  "forecastMaps.byZone": "Per zona",
  "forecastMaps.colormap": "Mapa de colors",
  "forecastMaps.colormapCustom": "Colors personalitzats",
  "forecastMaps.colormapGroupDomain": "Predefinits meteorològics",
  "forecastMaps.colormapGroupMatplotlib": "Predefinits científics",
  "forecastMaps.colorScale": "Escala de colors",
  "forecastMaps.contourLevels": "Nivells de contorn",
  "forecastMaps.countryCanada": "Canadà",
  "forecastMaps.countryFrance": "França",
  "forecastMaps.countryGermany": "Alemanya",
  "forecastMaps.countryItaly": "Itàlia",
  "forecastMaps.countryScandinavia": "Escandinàvia",
  "forecastMaps.countrySpain": "Espanya",
  "forecastMaps.countrySwitzerland": "Suïssa",
  "forecastMaps.countryUnitedStates": "Estats Units",
  "forecastMaps.customColormapMinColors": "Un mapa de colors personalitzat necessita almenys dos colors",
  "forecastMaps.customExtent": "Extensió personalitzada",
  "forecastMaps.displayName": "Nom visible",
  "forecastMaps.downscaling": "Factor d'aprimament de barbes",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Dibuixa l'àrea",
  "forecastMaps.east": "Est",
  "forecastMaps.extentDrawHint": "Arrossegueu pel mapa per dibuixar l'àrea",
  "forecastMaps.extentInvalid": "L'oest ha de ser menor que l'est i el sud menor que el nord",
  "forecastMaps.height": "Alçada (polzades)",
  "forecastMaps.hourOffset": "+{hour} h",
  "forecastMaps.invalidHexColor": "Color no vàlid — utilitzeu #RRGGBB",
  "forecastMaps.layers": "Capes",
  "forecastMaps.layerTypeBarbs": "Barbes de vent",
  "forecastMaps.layerTypeContour": "Línies de contorn",
  "forecastMaps.layerTypeFilledContour": "Contorns emplenats",
  "forecastMaps.layerTypeMagnitude": "Magnitud",
  "forecastMaps.layerTypeRaster": "Ràster",
  "forecastMaps.layerTypeVectorField": "Camp vectorial",
  "forecastMaps.leave": "Surt",
  "forecastMaps.levelsCount": "Recompte",
  "forecastMaps.levelsInvalid": "Nivells de contorn no vàlids",
  "forecastMaps.levelsModeArange": "Pas fix",
  "forecastMaps.levelsModeExplicit": "Valors explícits",
  "forecastMaps.levelsModeLinspace": "Espaiats uniformement (recompte)",
  "forecastMaps.levelsStep": "Pas",
  "forecastMaps.levelsValues": "Valors",
  "forecastMaps.levelsValuesHint": "Separats per comes, ascendents",
  "forecastMaps.localTimeHint": "Mostrat en la vostra hora local",
  "forecastMaps.mapDescription": "Descripció",
  "forecastMaps.mapName": "Nom del mapa",
  "forecastMaps.mapNameRequired": "Introduïu un nom",
  "forecastMaps.mapSettings": "Configuració del mapa",
  "forecastMaps.mapView": "Mapa interactiu",
  "forecastMaps.maxLayersReached": "Aquest mapa ha arribat al màxim de {max} capes.",
  "forecastMaps.maxValue": "Valor màxim",
  "forecastMaps.memoryBudgetExceeded": "La resolució supera el pressupost de renderització — reduïu el DPI o l'alçada",
  "forecastMaps.memoryBudgetUsage": "Pressupost de renderització: {percent}%",
  "forecastMaps.metaDescription": "Mapes de previsió animats renderitzats a partir d'execucions de models meteorològics.",
  "forecastMaps.metric": "Mètrica",
  "forecastMaps.metricRequired": "Seleccioneu una mètrica",
  "forecastMaps.metricUnavailable": "No disponible per a aquest model",
  "forecastMaps.minBelowMax": "El mínim ha de ser menor que el màxim",
  "forecastMaps.minMaxRequired": "Els valors mínim i màxim són obligatoris per a aquest tipus de capa",
  "forecastMaps.minValue": "Valor mínim",
  "forecastMaps.modelNoRun": "Encara no hi ha cap execució completada",
  "forecastMaps.moveLayerDown": "Mou avall",
  "forecastMaps.moveLayerUp": "Mou amunt",
  "forecastMaps.myMaps": "Els meus mapes",
  "forecastMaps.nanClipToMin": "Retalla al mínim",
  "forecastMaps.nanMask": "Màscara",
  "forecastMaps.nanPolicy": "Dades absents",
  "forecastMaps.nanSkip": "Omet",
  "forecastMaps.noCompletedRun": "Aquest mapa encara no s'ha renderitzat. Torneu-hi aviat.",
  "forecastMaps.noLayers": "Encara no hi ha capes. Afegiu una capa per començar.",
  "forecastMaps.noMapsAvailable": "Encara no hi ha cap mapa de previsió disponible.",
  "forecastMaps.north": "Nord",
  "forecastMaps.opacity": "Opacitat",
  "forecastMaps.overlayLegend": "Llegenda",
  "forecastMaps.pause": "Pausa",
  "forecastMaps.play": "Reprodueix",
  "forecastMaps.pointValueError": "No s'ha pogut carregar la previsió per a aquest punt.",
  "forecastMaps.pointValueLoading": "S'està carregant la previsió…",
  "forecastMaps.pointValueUnavailable": "No hi ha dades per a aquesta hora.",
  "forecastMaps.presets": "Predefinits",
  "forecastMaps.preview": "Vista prèvia",
  "forecastMaps.previewEmptyHint": "Configureu almenys una capa vàlida per renderitzar una vista prèvia.",
  "forecastMaps.previewFailed": "La vista prèvia ha fallat",
  "forecastMaps.previewHour": "Hora de previsió",
  "forecastMaps.previewRendering": "S'està renderitzant la vista prèvia…",
  "forecastMaps.projection": "Projecció",
  "forecastMaps.projectionLambertConformal": "Lambert conforme",
  "forecastMaps.projectionMercator": "Mercator",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Estereogràfica",
  "forecastMaps.regionEurope": "Europa",
  "forecastMaps.regionNorthAmerica": "Amèrica del Nord",
  "forecastMaps.removeColor": "Elimina el color",
  "forecastMaps.removeLayer": "Elimina la capa",
  "forecastMaps.retry": "Torna-ho a provar",
  "forecastMaps.run": "Execució: {run}",
  "forecastMaps.save": "Desa",
  "forecastMaps.selectExtentOnMap": "Selecciona l'àrea al mapa",
  "forecastMaps.south": "Sud",
  "forecastMaps.title": "Mapes de previsió",
  "forecastMaps.uMetric": "Component U",
  "forecastMaps.unitConversion": "Conversió d'unitats",
  "forecastMaps.unitNone": "Cap",
  "forecastMaps.unsavedChangesBody": "Teniu canvis sense desar. Voleu sortir i descartar-los?",
  "forecastMaps.unsavedChangesTitle": "Canvis sense desar",
  "forecastMaps.useCurrentView": "Utilitza la vista actual",
  "forecastMaps.useModelDomain": "Desactivat: s'utilitza tot el domini del model",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "Les mètriques U i V han de ser diferents",
  "forecastMaps.valueBetween": "Ha d'estar entre {min} i {max}",
  "forecastMaps.variable": "Variable",
  "forecastMaps.viewMap": "Mostra el mapa",
  "forecastMaps.vMetric": "Component V",
  "forecastMaps.west": "Oest",
  "forecastMaps.windAnimation": "Animació del vent",
  "forecastModels.addForecastModel": "Afegeix un model",
  "forecastModels.atYourStations": "Disponibles a les vostres estacions",
  "forecastModels.coverageLoading": "Calculant quines estacions cobreix cada model…",
  "forecastModels.description_AROME": "Model d'alta resolució de Météo France que permet resoldre la convecció sobre l'Europa occidental amb una resolució d'1,3 km. El millor de la seva categoria per a previsions a curt termini a França; s'actualitza cada tres hores.",
  "forecastModels.description_ARPEGE_EU": "Subdomini europeu del model ARPEGE de Météo France amb una resolució de 10 km. Previsions de mitjà termini sobre Europa, actualitzades quatre vegades al dia.",
  "forecastModels.description_ARPEGE_GLOBAL": "Model meteorològic numèric global de Météo France amb una resolució de 25 km, que arriba fins a uns 4 dies. S'actualitza quatre vegades al dia.",
  "forecastModels.description_DMI_DINI": "HARMONIE DINI de DMI: un model que permet resoldre la convecció sobre el nord-oest d'Europa — Dinamarca, el Benelux, Irlanda, el Regne Unit i Escandinàvia — amb una resolució de 2 km que arriba fins a 60 hores, actualitzat vuit vegades al dia. Conté dades obertes de DMI modificades (CC BY 4.0).",
  "forecastModels.description_EC_GDPS": "Global Deterministic Prediction System (Sistema Global de Predicció Determinista) d'Environment Canada: un model mundial de mitjà termini amb una resolució de 15 km que arriba fins a 10 dies, actualitzat dues vegades al dia.",
  "forecastModels.description_EC_HRDPS": "High Resolution Deterministic Prediction System (Sistema d'Alta Resolució de Predicció Determinista) d'Environment Canada: un model que permet resoldre la convecció sobre el Canadà i el nord dels Estats Units amb una resolució de 2,5 km que arriba fins a 48 hores, actualitzat quatre vegades al dia.",
  "forecastModels.description_EC_RDPS": "Regional Deterministic Prediction System (Sistema Regional de Predicció Determinista) d'Environment Canada: un model de mitjà termini sobre Amèrica del Nord amb una resolució de 10 km, actualitzat quatre vegades al dia.",
  "forecastModels.description_ECMWF_HRES": "El model insígnia d'alta resolució (IFS) del Centre Europeu de Predicció a Mitjà Termini, àmpliament considerat el millor sistema de predicció global del món. Cobreix tot el planeta amb una resolució de 25 km fins a 15 dies, actualitzat quatre cops al dia. Conté dades obertes d'ECMWF modificades (CC BY 4.0).",
  "forecastModels.description_GFS": "El model global de mitjà termini insígnia de la NOAA. Cobreix tot el planeta amb una resolució de 25 km fins a 16 dies, actualitzat quatre vegades al dia.",
  "forecastModels.description_HRRR_CONUS": "High-Resolution Rapid Refresh de la NOAA: un model que permet resoldre la convecció sobre els Estats Units continentals amb una resolució de 3 km, actualitzat cada hora. El més adequat per a previsions a molt curt termini de tempestes i temps sever.",
  "forecastModels.description_ICON": "El model global ICON del DWD amb una resolució de 13 km que cobreix tot el planeta fins a 7,5 dies, actualitzat quatre vegades al dia. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_2I": "ICON-2I d'ItaliaMeteo, operat conjuntament amb ARPAE: un model que permet resoldre la convecció sobre Itàlia amb una resolució de 2,2 km que arriba fins a 72 hores, actualitzat dues vegades al dia. Conté dades obertes d'ItaliaMeteo (CC BY 4.0).",
  "forecastModels.description_ICON_CH1": "La passada de control d'ICON-CH1-EPS de MeteoSwiss: un model que permet resoldre la convecció sobre els Alps amb una resolució d'1 km que arriba fins a 33 hores, actualitzat cada tres hores.",
  "forecastModels.description_ICON_CH2": "La passada de control d'ICON-CH2-EPS de MeteoSwiss: un model que permet resoldre la convecció sobre els Alps — Suïssa i la regió alpina circumdant — amb una resolució de 2,1 km que arriba fins a 120 hores, actualitzat quatre vegades al dia.",
  "forecastModels.description_ICON_DE": "Model d'alta resolució del DWD que permet resoldre la convecció sobre Alemanya i els països del voltant amb una resolució de 2,2 km. Previsions a curt termini actualitzades dues vegades al dia. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_EU": "Subdomini europeu del model ICON del DWD amb una resolució de 7 km que cobreix Europa i l'Atlàntic Nord. Previsions de mitjà termini actualitzades quatre vegades al dia. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_MET_NORWAY": "El servei obert de previsió meteorològica de l'Institut Meteorològic Noruec, que combina models nòrdics d'alta resolució amb dades de l'ECMWF per oferir previsions a tot el món de fins a 10 dies vista.",
  "forecastModels.description_MF_AROME_ANTILLES": "Subdomini AROME sobre les Antilles franceses (Guadalupe, Martinica) amb una resolució de 2,5 km. Previsions a curt termini actualitzades quatre vegades al dia.",
  "forecastModels.description_MF_AROME_GUYANE": "Subdomini AROME sobre la Guaiana Francesa amb una resolució de 2,5 km. Previsions a curt termini actualitzades quatre vegades al dia.",
  "forecastModels.description_MF_AROME_NOUVELLE_CALEDONIE": "Subdomini AROME sobre Nova Caledònia amb una resolució de 2,5 km. Previsions a curt termini actualitzades quatre vegades al dia.",
  "forecastModels.description_MF_AROME_POLYNESIE": "Subdomini AROME sobre la Polinèsia Francesa amb una resolució de 2,5 km. Previsions a curt termini actualitzades quatre vegades al dia.",
  "forecastModels.description_MF_AROME_REUNION_MAYOTTE": "Subdomini AROME sobre la Reunió i Mayotte amb una resolució de 2,5 km. Previsions a curt termini actualitzades quatre vegades al dia.",
  "forecastModels.description_RRFS_CONUS": "El Rapid Refresh Forecast System de la NOAA sobre els Estats Units continentals amb 3 km de resolució. Prediccions horàries actualitzades vuit vegades al dia, fins a 84 hores en les quatre passades principals i 18 hores en la resta.",
  "forecastModels.description_RRFS_NORTH_AMERICA": "El Rapid Refresh Forecast System de la NOAA que cobreix tota l'Amèrica del Nord amb 13 km de resolució. Prediccions horàries fins a 84 hores, actualitzades quatre vegades al dia.",
  "forecastModels.description_SMARTMIXIN_MULTIMODEL": "La previsió insígnia de SmartMixin. Per a cada hora de la vostra ubicació, triem el millor model disponible —normalment un model regional d'alta resolució allà on n'hi ha (AROME a França, ICON-D2 a Alemanya, HRRR als Estats Units, ARPEGE Europe a tot el continent…) i recorrem a un model global a la resta— i després omplim els buits amb fonts veïnes. El resultat és una previsió única i contínua que cobreix qualsevol lloc del món fins a 14 dies, actualitzada automàticament cada vegada que s'actualitza qualsevol dels models subjacents.",
  "forecastModels.description_WEATHERFLOW_FORECAST": "La previsió global propietària de Weatherflow que combina diversos models meteorològics numèrics amb observacions de la seva xarxa d'estacions meteorològiques Tempest. Horitzó mundial de 10 dies.",
  "forecastModels.everywhereElse": "A qualsevol altre lloc",
  "forecastModels.everywhereElseFoot": "S'usa a qualsevol estació que els vostres models preferits no abastin.",
  "forecastModels.everywhereElsePick": "Trieu-ne un",
  "forecastModels.fallbackBlend": "Barreja SmartMixin",
  "forecastModels.fallbackBlendSub": "Combina diversos models, cadascun on és més fort.",
  "forecastModels.fallbackEcmwf": "ECMWF",
  "forecastModels.fallbackEcmwfSub": "ECMWF HRES allà on arriba.",
  "forecastModels.fallbackGfs": "GFS",
  "forecastModels.fallbackGfsSub": "El model global de la NOAA. El que fan servir avui tots els comptes.",
  "forecastModels.fallbackResolution": "Màxima resolució",
  "forecastModels.fallbackResolutionSub": "La malla més fina disponible a cada estació.",
  "forecastModels.forecastChipLabelWithRun": "{model}, execució {run}",
  "forecastModels.forecastChipRunHint": "Manteniu premut per mostrar o amagar l’última execució",
  "forecastModels.forecastComparisonDescription": "Compareu fàcilment els resultats dels models de previsió de diverses fonts",
  "forecastModels.forecastFollowingPreferences": "Segons les vostres preferències",
  "forecastModels.forecastModel": "Model de previsió",
  "forecastModels.forecastModelComparison": "Comparació de models de previsió",
  "forecastModels.forecastModelCoverage": "Cobertura",
  "forecastModels.forecastModelDescription": "Descripció",
  "forecastModels.forecastModels": "Models de previsió",
  "forecastModels.forecastModelScopeGlobal": "Global",
  "forecastModels.forecastModelScopeGlobalDescription": "Aquest model cobreix tot el planeta.",
  "forecastModels.forecastModelScopeRegional": "Regional",
  "forecastModels.forecastModelScopeRegionalDescription": "Aquest model només cobreix una regió específica.",
  "forecastModels.forecastModelSpecifications": "Especificacions",
  "forecastModels.forecastNoPinLocation": "Cap model preferit no arriba a aquesta ubicació; decideix «a qualsevol altre lloc».",
  "forecastModels.forecastNoPinStation": "Cap model preferit no arriba a aquesta estació; decideix «a qualsevol altre lloc».",
  "forecastModels.forecastNoPreferredModels": "Encara no hi ha cap model preferit definit.",
  "forecastModels.forecastOverrideElsewhere": "Les vostres preferències s’apliquen a qualsevol altre lloc.",
  "forecastModels.forecastPickForLocation": "O trieu-ne un per a aquesta ubicació",
  "forecastModels.forecastPickForStation": "O trieu-ne un per a aquesta estació",
  "forecastModels.forecastPinWinsLocation": "{model} — el vostre primer model preferit que arriba a aquesta ubicació.",
  "forecastModels.forecastPinWinsStation": "{model} — el vostre primer model preferit que arriba a aquesta estació.",
  "forecastModels.forecastServedNowHere": "Ara mateix aquí és {model}",
  "forecastModels.forecastSetForLocation": "Definit per a aquesta ubicació",
  "forecastModels.forecastSetForStation": "Definit per a aquesta estació",
  "forecastModels.forecastSettingsRowSub": "Models preferits, i què s’aplica a qualsevol altre lloc",
  "forecastModels.forecastStopUsingHere": "Deixa d’usar-lo aquí",
  "forecastModels.forecastUseForLocation": "Utilitza {model} per a aquesta ubicació",
  "forecastModels.forecastUseForStation": "Utilitza {model} per a aquesta estació",
  "forecastModels.forecastUsePreferred": "Utilitza els meus models preferits",
  "forecastModels.frequencyHourly": "Cada hora",
  "forecastModels.horizon": "Horitzó",
  "forecastModels.horizonValue": "fins a {value} hores",
  "forecastModels.meshSize": "Mida de la quadrícula",
  "forecastModels.pickerShowAll": "Mostra tot el catàleg",
  "forecastModels.pickerUnreachable": "{count, plural, one {# model més no arriba} other {# models més no arriben}} a cap de les vostres estacions",
  "forecastModels.pinInUse": "En ús",
  "forecastModels.pinShadowed": "Mai no s'usa — un model superior cobreix totes les vostres estacions",
  "forecastModels.pinSlots": "{used} de {max} · trieu un model",
  "forecastModels.pinSlotsFull": "{max, plural, one {L’única plaça està ocupada. Traieu-ne el model per afegir-ne un altre.} other {Les # places estan ocupades. Traieu-ne una per afegir-ne una altra.}}",
  "forecastModels.pinsUncoveredCount": "{used} de les vostres {count, plural, one {# estació} other {# estacions}}: cap model preferit no hi arriba; decideix «a qualsevol altre lloc».",
  "forecastModels.pinsUncoveredNamed": "{stations}: cap model preferit no {count, plural, one {hi arriba} other {hi arriba}}; decideix «a qualsevol altre lloc».",
  "forecastModels.pinUnreachable": "Mai no s'usa — no arriba a cap de les vostres estacions",
  "forecastModels.pinUsedAt": "S'usa a {stations}",
  "forecastModels.pinUsedAtAll": "{count, plural, one {S'usa a la vostra estació} other {S'usa a les # estacions}}",
  "forecastModels.pinUsedAtSome": "S'usa a {used} de {count, plural, one {# estació} other {# estacions}}",
  "forecastModels.preferredModels": "Models preferits",
  "forecastModels.preferredModelsAll": "Una llista, totes les estacions",
  "forecastModels.preferredModelsOne": "Una llista, s'aplica a tot arreu",
  "forecastModels.publisher": "Editor",
  "forecastModels.removePreferredModel": "Treu {model} dels vostres models preferits",
  "forecastModels.resetForecastPreference": "Restableix",
  "forecastModels.resetForecastPreferenceHint": "Esborra els vostres models preferits i torna a la configuració predeterminada de SmartMixin.",
  "forecastModels.servedNowMany": "Ara mateix: GFS {count, plural, one {a la vostra estació} other {a les # estacions}}.",
  "forecastModels.servedNowNone": "Ara mateix: GFS a tot arreu.",
  "forecastModels.title_SMARTMIXIN_MULTIMODEL": "SmartMixin multimodel",
  "forecastModels.title_WEATHERFLOW_FORECAST": "Previsió Weatherflow",
  "forecastModels.weatherForecastModels": "Models de previsió meteorològica",
  "helpCenter.articleCount": "{count, plural, one {# article} other {# articles}}",
  "helpCenter.articleNotFound": "No s'ha trobat l'article",
  "helpCenter.articleNotFoundDescription": "L'article que busqueu no existeix.",
  "helpCenter.backToHelpCenter": "Torna al Centre d'ajuda",
  "helpCenter.browseByCategory": "Explora per categoria",
  "helpCenter.categoryNotFound": "No s'ha trobat la categoria",
  "helpCenter.categoryNotFoundDescription": "Aquesta categoria no existeix o no té cap article.",
  "helpCenter.contactSupport": "Contacta amb el servei d'assistència",
  "helpCenter.feedbackHelpsImprove": "Els vostres comentaris ens ajuden a millorar els articles d'ajuda.",
  "helpCenter.feedbackReasonNotAnswer": "No respon la meva pregunta",
  "helpCenter.feedbackReasonOutdated": "La informació està desactualitzada",
  "helpCenter.feedbackReasonUnclear": "Les instruccions no són clares",
  "helpCenter.feedbackWhatWentWrong": "Quin ha estat el problema?",
  "helpCenter.helpCategoryAccount": "Compte",
  "helpCenter.helpCategoryBilling": "Facturació",
  "helpCenter.helpCategoryForecast": "Previsions",
  "helpCenter.helpCategoryGettingStarted": "Primers passos",
  "helpCenter.helpCategoryProviders": "Proveïdors",
  "helpCenter.helpCategoryStations": "Estacions",
  "helpCenter.helpCategoryTroubleshooting": "Resolució de problemes",
  "helpCenter.helpCenter": "Centre d'ajuda",
  "helpCenter.landingDescription": "Trobeu respostes a les preguntes més freqüents i apreneu a treure el màxim profit de SmartMixin.",
  "helpCenter.linkToSection": "Enllaç a aquesta secció",
  "helpCenter.menuItemDescription": "Preguntes freqüents i guies",
  "helpCenter.minRead": "{minutes} min de lectura",
  "helpCenter.onThisPage": "En aquesta pàgina",
  "helpCenter.platformMobileApp": "Aplicació mòbil",
  "helpCenter.platformMobileOnly": "Només a l'aplicació mòbil",
  "helpCenter.platformWebApp": "Aplicació web",
  "helpCenter.platformWebOnly": "Només a l'aplicació web",
  "helpCenter.popularArticles": "Articles populars",
  "helpCenter.relatedArticles": "Articles relacionats",
  "helpCenter.searchArticles": "Cerca articles...",
  "helpCenter.stillNeedHelp": "Encara necessiteu ajuda?",
  "helpCenter.stillNeedHelpDescription": "Si aquest article no ha respost la vostra pregunta, estaré encantat d'ajudar-vos directament.",
  "helpCenter.supportEmailSubject": "Ajuda de SmartMixin",
  "helpCenter.supportEmailSubjectTopic": "Ajuda de SmartMixin — {topic}",
  "helpCenter.thankYouForFeedback": "Gràcies pels vostres comentaris!",
  "helpCenter.wasArticleHelpful": "Us ha estat útil aquest article?",
  "intro.locationDescription": "Activeu l'accés a la ubicació per obtenir prediccions meteorològiques precises adaptades a la vostra zona exacta — s'han acabat les previsions genèriques.",
  "intro.locationTitle": "Previsions fetes per a vós",
  "intro.notificationDescription": "Activeu les notificacions per rebre alertes oportunes sobre els canvis meteorològics que us importen — pluja, neu o condicions severes, just quan ho necessiteu saber.",
  "intro.notificationsTitle": "No us perdeu mai cap canvi de temps",
  "intro.readyDescription": "Gaudiu de previsions precises, informació meteorològica en temps real i dades d'estacions d'arreu del món — tot en una sola aplicació potent.",
  "intro.readyTitle": "Ja ho teniu tot a punt!",
  "intro.welcomeDescription": "Obteniu previsions hiperlocals amb la tecnologia de les principals agències meteorològiques — a més d'accés a més de 40.000 estacions meteorològiques d'arreu del món per veure les condicions reals, passades i presents.",
  "intro.welcomeTitle": "El vostre temps, reinventat",
  "landing.alsoAvailableOn": "També disponible a:",
  "landing.featureAlertsDescription": "Establiu llindars personalitzats per a qualsevol mètrica. Rebeu una notificació quan la temperatura baixi, comenci a ploure o s'aixequi el vent.",
  "landing.featureAlertsTitle": "Alertes intel·ligents",
  "landing.featureAnalyticsDescription": "Gràfics interactius, anàlisi de tendències i estadístiques detallades. Aprofundiu en les dades de temperatura, humitat, pressió, pluja i vent.",
  "landing.featureAnalyticsTitle": "Analítica avançada",
  "landing.featureExportDescription": "Rebeu totes les vostres dades meteorològiques per correu electrònic en un full de càlcul d'Excel, a punt per analitzar-les amb Excel, Google Sheets o les vostres eines preferides.",
  "landing.featureExportTitle": "Exporteu les vostres dades",
  "landing.featureForecastDescription": "Accediu a {count, plural, one {#+ model de previsió professional} other {#+ models de previsió professionals}}, com ara ECMWF, GFS i models regionals. Compareu-los de costat per fer les vostres pròpies prediccions.",
  "landing.featureForecastTitle": "Compareu models de previsió",
  "landing.featureHistoryDescription": "Accediu a dades històriques amb escales horàries, diàries i mensuals. Exporteu-les a Excel per a recerca o arxius personals.",
  "landing.featureHistoryTitle": "Historial complet",
  "landing.featureMultiBrandDescription": "Connecteu Netatmo, Davis, Tempest, Ecowitt, Ambient Weather i més. S'ha acabat canviar d'una aplicació a una altra.",
  "landing.featureMultiBrandTitle": "Totes les marques, una aplicació",
  "landing.featuresSubtitle": "SmartMixin us dona les eines per analitzar, comparar i entendre les vostres dades meteorològiques com un professional.",
  "landing.featuresTitle": "Fet per als amants de les dades",
  "landing.finalCtaButton": "Crea un compte gratuït",
  "landing.finalCtaSubtitle": "Uniu-vos a milers d'aficionats a la meteorologia que confien en SmartMixin.",
  "landing.finalCtaTitle": "A punt per aprofundir en les vostres dades meteorològiques?",
  "landing.heroCta": "Comença gratis",
  "landing.heroDescription": "Analítica en profunditat, gràfics elegants i previsions professionals — totes les vostres estacions meteorològiques unificades en una sola aplicació potent.",
  "landing.heroSecondaryCta": "Explora el mapa",
  "landing.heroTagline": "Per als aficionats a la meteorologia",
  "landing.heroTitle": "Vegeu el vostre temps com mai abans",
  "landing.pricingFeatureAdvancedMetrics": "Mètriques avançades",
  "landing.pricingFeatureAlerts": "Alertes personalitzades",
  "landing.pricingFeatureExport": "Exportació de dades (Excel)",
  "landing.pricingFeatureForecastComparison": "Comparació de previsions",
  "landing.pricingFeatureForecasts": "Models de previsió",
  "landing.pricingFeatureForecastsFreeTier": "1 model",
  "landing.pricingFeatureForecastsPremiumTier": "{count, plural, one {#+ model} other {#+ models}}",
  "landing.pricingFeatureReports": "Anàlisi i informes",
  "landing.pricingFeatureStationComparison": "Comparació d'estacions",
  "landing.pricingFeatureWidgets": "Widgets de la pantalla d'inici",
  "landing.pricingFeatureYearOverYear": "Anàlisi interanual",
  "landing.pricingFreeCta": "Comença",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "El més popular",
  "landing.pricingPremiumCta": "Comença",
  "landing.pricingPremiumDescription": "Des d'1,99 €/mes — subscriviu-vos al web, a l'App Store o a Google Play",
  "landing.pricingSubtitle": "Comenceu gratis, milloreu quan necessiteu més potència.",
  "landing.pricingTitle": "Preus senzills i transparents",
  "landing.statBrands": "Marques compatibles",
  "landing.statForecasts": "Models de previsió",
  "landing.statStations": "Estacions meteorològiques",
  "landing.supportedDevicesNote": "A més, més de {count, number} estacions públiques de la xarxa de l’Organització Meteorològica Mundial",
  "landing.supportedDevicesSubtitle": "Connecteu la vostra estació meteorològica existent en minuts. Som compatibles amb {count, plural, one {# marca important} other {# marques importants}}, i cada cop més.",
  "landing.supportedDevicesTitle": "Funciona amb la vostra estació",
  "metrics.absolutePressure": "Pressió absoluta",
  "metrics.airDensity": "Densitat de l'aire",
  "metrics.airGap": "Espai d'aire",
  "metrics.apparentTemperature": "Temperatura aparent",
  "metrics.AQI": "AQI",
  "metrics.AQI_24H": "AQI 24h",
  "metrics.avg": "Mitj.",
  "metrics.avg_wind": "Vent mitjà",
  "metrics.beaufort": "Beaufort",
  "metrics.blackGlobeTemperature": "Temp. de globus negre",
  "metrics.boilerOn": "Caldera encesa",
  "metrics.boilerOnInHours": "Caldera encesa (hores)",
  "metrics.co2": "CO2",
  "metrics.conductivity": "Conductivitat",
  "metrics.dailyPrecipitation": "Precipitació diària",
  "metrics.dailyRain": "Pluja diària",
  "metrics.degreeDayShort": "GD",
  "metrics.depth": "Profunditat",
  "metrics.depthSensors": "Sensors de profunditat",
  "metrics.dewPoint": "Punt de rosada",
  "metrics.distance": "Distància",
  "metrics.downTrend": "descendent",
  "metrics.ET": "Evapotranspiració",
  "metrics.etToday": "ET avui",
  "metrics.feelsLike": "Sensació tèrmica",
  "metrics.feelsLikeWithFormula": "Sensació tèrmica ({formula})",
  "metrics.frostPoint": "Punt de gebrada",
  "metrics.gust": "Ràfega",
  "metrics.hail": "Calamarsa",
  "metrics.heatIndex": "Índex de calor",
  "metrics.heatingDegreeDays": "Graus dia de calefacció",
  "metrics.heatingPower": "Potència de calefacció",
  "metrics.humidex": "Humidex",
  "metrics.humidity": "Humitat",
  "metrics.lastLightningImpact": "Últim impacte",
  "metrics.lastMeasure": "Última mesura",
  "metrics.leafSensors": "Sensors foliars",
  "metrics.leafWetness": "Humectació foliar",
  "metrics.lightningDistance": "Distància",
  "metrics.lightningStrikeCount": "Nombre de llamps",
  "metrics.lightningStrikeDistance": "Distància dels llamps",
  "metrics.max": "Màx.",
  "metrics.max_gust": "Ràfega màx.",
  "metrics.maxToday": "Màx. avui",
  "metrics.min": "Mín.",
  "metrics.noise": "Soroll",
  "metrics.normalizedHeatingCoefficient": "Coeficient de calefacció normalitzat",
  "metrics.outdoorTemperature": "Temperatura exterior",
  "metrics.PM_1": "PM1",
  "metrics.PM_10": "PM10",
  "metrics.PM_2P5": "PM2.5",
  "metrics.precipitation": "Precipitació",
  "metrics.pressure": "Pressió",
  "metrics.rain": "Pluja",
  "metrics.rainDurationValue": "Durada de la pluja: {duration}",
  "metrics.rainfallMeasurement": "Mesura de la precipitació",
  "metrics.rainRate": "Intensitat de pluja",
  "metrics.relativePressure": "Pressió relativa",
  "metrics.setPoint": "Consigna",
  "metrics.snow": "Neu",
  "metrics.snowfall": "Nevada",
  "metrics.soilMoisture": "Humitat",
  "metrics.soilSensors": "Sensors del sòl",
  "metrics.soilWaterTension": "Tensió hídrica del sòl",
  "metrics.solarEnergy": "Energia solar",
  "metrics.solarRadiation": "Radiació solar",
  "metrics.speed": "Velocitat",
  "metrics.stableTrend": "estable",
  "metrics.sum": "Suma",
  "metrics.temperature": "Temperatura",
  "metrics.temperatureSensors": "Sensors de temperatura i humitat",
  "metrics.temperatureShort": "Temp.",
  "metrics.thsw": "THSW",
  "metrics.thw": "THW",
  "metrics.upTrend": "ascendent",
  "metrics.uv": "UV",
  "metrics.visibility": "Visibilitat",
  "metrics.weatherCondition": "Condició meteorològica",
  "metrics.wetBulbGlobeTemperature": "Temp. de globus de bulb humit",
  "metrics.wetBulbTemperature": "Temp. de bulb humit",
  "metrics.wind": "Vent",
  "metrics.windChill": "Sensació de fred",
  "metrics.windDirection": "Direcció del vent",
  "metrics.windMeasurement": "Mesura del vent",
  "metrics.windRun": "Recorregut del vent",
  "metrics.windRunDescription": "El recorregut del vent és la distància total que recorre el vent durant un període de temps",
  "metrics.windSpeed": "Velocitat del vent",
  "network.cancelError": "S'ha cancel·lat la sol·licitud",
  "network.connectionError": "El servidor no està disponible",
  "network.networkError": "La xarxa no està disponible",
  "network.serverError": "Alguna cosa ha anat malament...",
  "network.timeoutError": "Temps de connexió esgotat",
  "network.unknownError": "Error desconegut",
  "premium.alreadyPremium": "Ja teniu un compte premium!",
  "premium.bestValue": "Millor relació qualitat-preu",
  "premium.billingDetailsAndroid": "Prova gratuïta: no se us cobrarà res si cancel·leu com a mínim 24 hores abans que acabi la prova. Després, la vostra subscripció a SmartMixin es renova automàticament tret que la cancel·leu com a mínim 24 hores abans del final del període en curs; podeu cancel·lar-la en qualsevol moment a la configuració del vostre compte de Google Play. Cada renovació es cobra al preu que es mostra al botó de dalt. El pagament es carrega al vostre compte de Google Play quan confirmeu la compra i a l'inici de cada període de renovació.",
  "premium.billingDetailsIos": "Prova gratuïta: no se us cobrarà res si cancel·leu com a mínim 24 hores abans que acabi la prova. Després, la vostra subscripció a SmartMixin es renova automàticament tret que la cancel·leu com a mínim 24 hores abans del final del període en curs; podeu cancel·lar-la en qualsevol moment a la configuració del vostre compte de l'App Store. Cada renovació es cobra al preu que es mostra al botó de dalt. El pagament es carrega al vostre compte de l'App Store quan confirmeu la compra i a l'inici de cada període de renovació.",
  "premium.freeBannerBody": "Els comptes gratuïts reben GFS a tot arreu: els vostres models preferits i «a qualsevol altre lloc» comencen a funcionar tan bon punt us subscriviu.",
  "premium.freeBannerTitle": "Les preferències s'apliquen amb Premium",
  "premium.freeSubscription": "Subscripció premium gratuïta",
  "premium.freeTrialForPeriod": "Prova gratuïta de {period, plural, one {# dia} other {# dies}}",
  "premium.getUnlimitedAccess": "Obteniu accés il·limitat a:",
  "premium.manageMySubscription": "Gestiona la meva subscripció",
  "premium.notPurchasedYet": "No s'ha trobat cap compra de SmartMixin Premium en aquest compte de la botiga.",
  "premium.orChooseMonthly": "O trieu mensual:",
  "premium.premium": "SmartMixin Premium",
  "premium.premiumActive": "Activa",
  "premium.premiumAnnualTrialInfo": "Comenceu amb una prova gratuïta de {days, plural, one {# dia} other {# dies}}",
  "premium.premiumCurrentPlan": "Pla actual",
  "premium.premiumDownloadApp": "Descarregueu l'aplicació per subscriure-us:",
  "premium.premiumEndsOn": "Caduca el {date}",
  "premium.premiumFeatureAlerts": "Alertes meteorològiques",
  "premium.premiumFeatureAnalysis": "Anàlisi meteorològica avançada",
  "premium.premiumFeatureCharts": "Comparacions de gràfics",
  "premium.premiumFeatureExport": "Exportació de dades",
  "premium.premiumFeatureForecast": "Models de previsió regionals",
  "premium.premiumFeatureNotification": "Widget de la barra d'estat",
  "premium.premiumFeatureTitle": "Funció Premium",
  "premium.premiumFeatureWidgets": "Widgets de la pantalla d'inici",
  "premium.premiumFreePlan": "Gratuït",
  "premium.premiumInactive": "Sense subscripció",
  "premium.premiumManageStoreSubscription": "La vostra subscripció es va fer a la botiga {store}. Gestioneu-la o cancel·leu-la allà.",
  "premium.premiumManageWebSubscription": "Gestioneu la vostra subscripció, actualitzeu el mètode de pagament o cancel·leu-la.",
  "premium.premiumPremiumPlan": "Premium",
  "premium.premiumRenewsOn": "Es renova el {date}",
  "premium.premiumSubscribeAnnual": "Anual — 9,99 €/any",
  "premium.premiumSubscribedOn": "Subscrit a {platform}",
  "premium.premiumSubscribedOnWeb": "Subscrit al web",
  "premium.premiumSubscribeMonthly": "Mensual — 1,99 €/mes",
  "premium.premiumSubscribeOnWeb": "Subscriviu-vos ara per desbloquejar totes les funcions premium.",
  "premium.premiumSubscriptionSuccess": "La vostra subscripció s'ha activat! Gaudiu de totes les funcions premium.",
  "premium.premiumSubscriptionSuccessTitle": "Us donem la benvinguda a Premium!",
  "premium.premiumWebappNotice": "La subscripció al web no està disponible ara mateix.",
  "premium.pricePerMonth": "{price}/mes",
  "premium.pricePerYear": "{price}/any",
  "premium.purchasedNetatmoPro": "Anteriorment vau comprar Netatmo Pro ({date}). Us dóna accés a un subconjunt de funcions premium. Subscriviu-vos a una de les ofertes següents si voleu tenir accés a totes les funcions premium.",
  "premium.purchaseFailed": "No s'ha pogut completar la compra. Torneu-ho a provar.",
  "premium.restoreFailed": "No s'han pogut restaurar les compres. Torneu-ho a provar.",
  "premium.restorePurchase": "Restaura la compra",
  "premium.savingsPercent": "Estalvieu {percent}%",
  "premium.seePremium": "Descobreix Premium",
  "premium.startFreeTrial": "Comença la prova gratuïta",
  "premium.storeUnavailable": "La botiga no està disponible ara mateix. Torneu-ho a provar més tard.",
  "premium.subscribeNow": "Subscriu-te ara — sense prova",
  "premium.switchToPremium": "Canvia a SmartMixin Premium",
  "premium.thenPrice": "després {price}",
  "providerHints.ambientWeatherApiKey": "Creada a la configuració del vostre compte d'ambientweather.net.",
  "providerHints.davisApiSecret": "Es mostra només un cop quan vau crear la clau API V2 — guardeu-lo en un lloc segur.",
  "providerHints.davisV2ApiKey": "De la pàgina de claus API V2 del vostre compte de weatherlink.com.",
  "providerHints.ecowittApi": "De la pàgina d'API del vostre compte d'Ecowitt.",
  "providerHints.ecowittApp": "La clau d'aplicació (Application key), també del vostre compte d'Ecowitt.",
  "providerHints.myAcuriteCredentialsBanner": "Feu servir el correu electrònic i la contrasenya del vostre compte My AcuRite, no les credencials de SmartMixin.",
  "providerHints.myAcuriteEmail": "El correu electrònic del vostre compte My AcuRite, no les credencials de SmartMixin.",
  "providerHints.myAcuritePassword": "La contrasenya del vostre compte My AcuRite.",
  "providerHints.weatherflowToken": "Token d'ús personal de tempestwx.com → configuració → autoritzacions de dades.",
  "providerHints.wundergroundEditKey": "Utilitza una clau diferent",
  "providerHints.wundergroundKey": "Una cadena llarga de la pàgina de claus API de membre de Weather Underground, no la contrasenya de wunderground.com.",
  "providerHints.wundergroundKeyExample": "p. ex. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "Clau API verificada",
  "providerHints.wundergroundNoStationsNearby": "No s'ha trobat cap estació a prop d'aquesta ubicació. Proveu d'introduir un identificador d'estació directament.",
  "providerHints.wundergroundStationIdExample": "p. ex. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Obteniu la vostra clau API d'Ambient Weather.",
  "providerIntro.davisStep2": "Obteniu la vostra clau API i el secret API de Davis V2.",
  "providerIntro.ecowittStep2": "Obteniu la vostra clau API i clau d'aplicació d'Ecowitt.",
  "providerIntro.getStarted": "Comença",
  "providerIntro.myAcuriteStep2": "Feu servir el correu electrònic i la contrasenya del vostre compte My AcuRite actual.",
  "providerIntro.netatmoEnergyStep2": "Inicieu la sessió a Netatmo quan se us demani; no cal cap clau API.",
  "providerIntro.netatmoWeatherStep2": "Inicieu la sessió a Netatmo quan se us demani; no cal cap clau API.",
  "providerIntro.signupBanner": "Ja gairebé hi sou: creeu el vostre compte gratuït de SmartMixin per connectar {provider}.",
  "providerIntro.step1": "Inicieu la sessió al vostre compte de SmartMixin (NO amb les credencials de {provider}).",
  "providerIntro.step3EmailPassword": "Introduïu-los aquí.",
  "providerIntro.step3KeyOrToken": "Enganxeu-ho aquí.",
  "providerIntro.step3OAuth": "Autoritzeu SmartMixin a la finestra emergent.",
  "providerIntro.step3Wunderground": "Enganxeu la vostra clau API i, tot seguit, trieu una estació propera o introduïu qualsevol identificador d'estació.",
  "providerIntro.title": "Connecta {provider}",
  "providerIntro.weatherflowStep2": "Obteniu el vostre token d'ús personal de Tempest.",
  "providerIntro.wundergroundBrowsePublic": "No teniu cap estació? Exploreu-ne de públiques",
  "providerIntro.wundergroundFindNearby": "Cerca estacions a prop meu",
  "providerIntro.wundergroundOrEnterId": "O introduïu un identificador d'estació",
  "providerIntro.wundergroundStep2": "Obteniu la vostra clau API de Weather Underground. Després podreu connectar qualsevol estació: la vostra o una de pública.",
  "reports.agroMeteorology": "Agrometeorologia",
  "reports.analysis": "Anàlisi",
  "reports.annualCumulativeRainfallComparison": "Comparació de la precipitació acumulada anual",
  "reports.annualHeatingDurationComparison": "Comparació de la durada de la calefacció anual",
  "reports.annualHeatingEfficiency": "Eficiència de calefacció anual",
  "reports.annualIndoorComparison": "Comparació d'interior anual",
  "reports.annualOutdoorComparison": "Comparació d'exterior anual",
  "reports.annualOutdoorReport": "Informe d'exterior anual",
  "reports.annualReport": "Informe anual",
  "reports.annualSolarReport": "Informe solar anual",
  "reports.annualWaterBalance": "Balanç hídric anual",
  "reports.annualWaterBalanceCarryOver": "Trasllada {year} ({value})",
  "reports.annualWaterBalanceDescription": "El balanç hídric (versió simplificada, només s'utilitzen la pluja i l'evapotranspiració) ajuda a gestionar el subministrament d'aigua",
  "reports.avgHumidity": "Humitat mitjana",
  "reports.avgMaxTemperature": "T°max mitjana",
  "reports.avgMetric": "Mitjana – {metric}",
  "reports.avgMinTemperature": "T°min mitjana",
  "reports.avgPressure": "Pressió mitjana",
  "reports.avgTemperature": "Temperatura mitjana",
  "reports.chartsAndTable": "Gràfics i taula",
  "reports.climateNormalPeriodOfRecord": "Període d'observació ({years, plural, one {# any} other {# anys}})",
  "reports.climateNormals": "Normals climàtiques",
  "reports.climateNormalStandardLabel": "Normal estàndard ({period})",
  "reports.climateTrendPerDecade": "Tendència de la temperatura: {value} per dècada al llarg de {years, plural, one {# any} other {# anys}}",
  "reports.coldestMonthRanking": "{month} més fred registrat",
  "reports.comfortable": "Confortable (45% {lessThan} Humitat ≤ 60%)",
  "reports.cumulativeRainfall": "Precipitació acumulada",
  "reports.cumulativeRainfallDescription": "Feu un seguiment de la precipitació total acumulada durant el període seleccionat.",
  "reports.dailyMaxRainfall": "Precipitació màx. diària",
  "reports.dataExport": "Exporta les dades",
  "reports.dataExportXlsxFormatDescription": "Exporteu totes les dades de la vostra estació en format Excel (*.xlsx). Un cop feu clic al botó, rebreu un correu electrònic amb les dades processades al cap d'uns minuts.",
  "reports.daysOfData": "{days, plural, one {# dia} other {# dies}} de dades",
  "reports.daysWithFrost": "Dies amb gelada",
  "reports.daysWithHeavyRain": "Dies de pluja intensa (≥ {threshold})",
  "reports.daysWithoutThaw": "Dies sense desglaç",
  "reports.daysWithStrongFrost": "Dies amb gelada forta",
  "reports.emailSent": "S'ha enviat un correu electrònic a la vostra bústia",
  "reports.frostDays": "Dies de glaçada",
  "reports.grasslandTemperatureSum": "Suma de temperatura de prats",
  "reports.grasslandTemperatureSumDescription": "Si a la primavera se supera la suma de {threshold}, s'ha assolit l'inici sostenible de la vegetació (funciona a Europa)",
  "reports.growingDegreeDays": "Graus dia de creixement",
  "reports.highPressure": "Anticicló (Pressió mitjana ≥ 1013mbar)",
  "reports.iceDays": "Dies glaçats",
  "reports.indoorReport": "Informe d'interior",
  "reports.keyFacts": "Dades clau",
  "reports.longestDrySpell": "Ratxa seca més llarga",
  "reports.longestRunOfRainyDays": "Ratxa més llarga de dies plujosos",
  "reports.longestRunWithoutRun": "Ratxa més llarga sense pluja",
  "reports.longestWetSpell": "Ratxa humida més llarga",
  "reports.lowPressure": "Baixa pressió (Pressió mitjana {lessThan} 1013mbar)",
  "reports.maxHumidity": "Humitat màxima",
  "reports.maxMetric": "Màxim – {metric}",
  "reports.maxPressure": "Pressió màxima",
  "reports.maxTemperature": "Temperatura màxima",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Amplitud màxima (/24H)",
  "reports.minHumidity": "Humitat mínima",
  "reports.minMetric": "Mínim – {metric}",
  "reports.minPressure": "Pressió mínima",
  "reports.minTemperature": "Temperatura mínima",
  "reports.minTempMagnitude24h": "Amplitud mínima (/24H)",
  "reports.monthlyAverageCountdown": "{days, plural, one {# dia més} other {# dies més}} aquest mes",
  "reports.monthlyAverageCountdownDetail": "Llavors apareixeran la mitjana del mes i la seva classificació.",
  "reports.monthlyAverageRule": "Les mitjanes mensuals i les classificacions apareixen quan un mes natural té {days, plural, one {# dia} other {# dies}} registrats.",
  "reports.monthlyHeatingEfficiency": "Eficiència de calefacció mensual",
  "reports.monthlyOutdoorReport": "Informe d'exterior mensual",
  "reports.monthlyReport": "Informe mensual",
  "reports.monthlySolarReport": "Informe solar mensual",
  "reports.monthlyWindReport": "Informe del vent mensual",
  "reports.monthsOfData": "{months, plural, one {# mes} other {# mesos}} de dades",
  "reports.numberOfDays": "Nombre de dies",
  "reports.outdoorReport": "Informe d'exterior",
  "reports.overviewSection": "Resum",
  "reports.rainfall": "Precipitació",
  "reports.rainyDays": "Dies plujosos",
  "reports.recordDailyRain": "Dia més plujós",
  "reports.recordHigh": "Rècord de calor",
  "reports.recordLow": "Rècord de fred",
  "reports.recordsAndClimatology": "Rècords i clima",
  "reports.recordsSince": "Rècords des de {date}",
  "reports.recordWindGust": "Ratxa de vent més forta",
  "reports.relativelyWet": "Relativament humit (60% {lessThan} Humitat ≤ 80%)",
  "reports.sectionReportCount": "{count, plural, one {# informe} other {# informes}}",
  "reports.sendEmail": "Envia el correu electrònic",
  "reports.summerDays": "Dies d'estiu",
  "reports.tooDry": "Massa sec (Humitat ≤ 45%)",
  "reports.tooWet": "Massa humit (Humitat {greaterThan} 80%)",
  "reports.tropicalNights": "Nits tropicals",
  "reports.unlockPremiumSubtitle": "Inclòs amb SmartMixin Premium",
  "reports.unlockPremiumTitle": "Desbloqueja {count, plural, one {# funció premium} other {# funcions premium}}",
  "reports.warmestMonthRanking": "{month} més càlid registrat",
  "reports.waterBalance": "Balanç hídric",
  "reports.yearsOfData": "{years, plural, one {# any} other {# anys}} de dades",
  "reports.yearToDateTemperatureComparison": "Comparació de la temperatura de l'any fins ara",
  "sensors.bgtSensors": "Globus negre i WBGT",
  "sensors.cameraFeed": "Càmera",
  "sensors.compareHumidity": "Compara la humitat",
  "sensors.compareMoisture": "Compara la humitat del sòl",
  "sensors.comparePm25": "Compara el PM2.5",
  "sensors.compareTemperatures": "Compara les temperatures",
  "sensors.compareWaterTension": "Compara la tensió hídrica del sòl",
  "sensors.depthByChannel": "Profunditat per canal",
  "sensors.heatStressExtreme": "Estrès tèrmic extrem",
  "sensors.heatStressModerate": "Estrès tèrmic moderat",
  "sensors.heatStressNone": "Sense estrès tèrmic",
  "sensors.heatStressStrong": "Estrès tèrmic fort",
  "sensors.heatStressVeryStrong": "Estrès tèrmic molt fort",
  "sensors.indoorClimate": "Clima interior",
  "sensors.indoorCo2Levels": "Nivells de CO2",
  "sensors.indoorTemperatureAndHumidity": "Temperatura i humitat",
  "sensors.leafWetnessByChannel": "Humectació foliar per canal",
  "sensors.lightningSensor": "Llamps",
  "sensors.moistureByChannel": "Humitat del sòl per canal",
  "sensors.noDataAvailable": "No hi ha dades disponibles",
  "sensors.pm10AndAqi": "PM10 i AQI",
  "sensors.pm1AndAqi": "PM1.0 i AQI",
  "sensors.pm25AndAqi": "PM2.5 i AQI",
  "sensors.pm25ByChannel": "PM2.5 per canal",
  "sensors.pm4AndAqi": "PM4.0 i AQI",
  "sensors.selectChannel": "Selecciona el canal",
  "sensors.sensorDetailDescription": "Consulteu les dades històriques i les tendències dels canals dels vostres sensors.",
  "sensors.sensorHistory": "Historial del sensor",
  "sensors.soilConductivityByChannel": "Conductivitat per canal",
  "sensors.soilTemperatureByChannel": "Temperatura del sòl per canal",
  "sensors.strikesToday": "Impactes avui",
  "sensors.temperatureByChannel": "Temperatura per canal",
  "sensors.viewChart": "Mostra el gràfic",
  "sensors.waterTensionByChannel": "Tensió hídrica del sòl per canal",
  "settings.appearance": "Aparença",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "àrab",
  "settings.bulgarian": "búlgar",
  "settings.catalan": "català",
  "settings.chartGestures": "Gestos als gràfics",
  "settings.chartGesturesDescription": "Fer lliscar el dit pels gràfics canvia el període de temps; pessigar-los canvia l'escala de temps",
  "settings.choiceCount": "{count, plural, one {# disponible} other {# disponibles}}",
  "settings.contactUs": "Contacteu-nos",
  "settings.contactUsDescription": "Obteniu ajuda o envieu comentaris",
  "settings.croatian": "croat",
  "settings.czech": "txec",
  "settings.dailyDetailByPeriods": "Detall diari per períodes",
  "settings.dailyDetailByPeriodsDescription": "Agrupa les 24 hores en nit, matí, tarda i vespre — la mateixa divisió que fa servir el resum del dia.",
  "settings.danish": "danès",
  "settings.dark": "Tema fosc",
  "settings.dataDisplay": "Visualització de dades",
  "settings.dateAndTime": "Data i hora",
  "settings.donateButton": "Fes una donació",
  "settings.donateDescription": "SmartMixin està desenvolupat per un equip petit. Si us resulta útil, podeu donar suport al seu desenvolupament amb una donació única de qualsevol import. És un regal: no canvia el vostre pla ni desbloqueja cap funció.",
  "settings.donateSuccessBody": "La vostra donació ajuda a mantenir SmartMixin en funcionament i a millorar-lo. Us ho agraïm de tot cor.",
  "settings.donateSuccessTitle": "Gràcies pel vostre suport!",
  "settings.donateTitle": "Doneu suport a SmartMixin",
  "settings.dragToReorder": "Arrossega per reordenar",
  "settings.dutch": "neerlandès",
  "settings.english": "anglès",
  "settings.french": "francès",
  "settings.german": "alemany",
  "settings.gestures": "Gestos",
  "settings.greek": "grec",
  "settings.hungarian": "hongarès",
  "settings.italian": "italià",
  "settings.japanese": "japonès",
  "settings.korean": "coreà",
  "settings.language": "Idioma",
  "settings.languageDescription": "Idioma preferit",
  "settings.light": "Tema clar",
  "settings.measurementUnits": "Unitats de mesura",
  "settings.netatmoDashboard": "Tauler Netatmo",
  "settings.netatmoLayoutCards": "Llista de targetes",
  "settings.netatmoLayoutCardsDescription": "Una targeta per mòdul, tot en un desplaçament",
  "settings.netatmoLayoutClassic": "Clàssic",
  "settings.netatmoLayoutClassicDescription": "Dues targetes, llisca entre mòduls",
  "settings.netatmoNewLayoutNotice": "Nova disposició del tauler: una targeta per mòdul.",
  "settings.netatmoSwitchBackToClassic": "Torna al clàssic",
  "settings.netatmoSwitchToLayout": "Canvia a {layout}",
  "settings.norwegian": "noruec",
  "settings.notificationsSection": "Notificacions",
  "settings.ongoingNotificationEnabled": "Activa la notificació permanent",
  "settings.ongoingNotificationMetrics": "Mètriques mostrades",
  "settings.ongoingNotificationPermissionRequired": "Cal el permís de notificacions",
  "settings.ongoingNotificationPreviewHint": "Vista prèvia — activeu el widget per mostrar-lo",
  "settings.ongoingNotificationStatusBar": "Barra d'estat",
  "settings.polish": "polonès",
  "settings.portuguese": "portuguès",
  "settings.preferencesSection": "Preferències",
  "settings.privacyPolicy": "Política de privadesa",
  "settings.russian": "rus",
  "settings.serbian": "serbi",
  "settings.settings": "Configuració",
  "settings.settingsPageTitle": "Configuració - {page}",
  "settings.slovak": "eslovac",
  "settings.smallDecimals": "Decimals petits",
  "settings.smallDecimalsDescription": "Mostra els dígits decimals en una mida més petita",
  "settings.spanish": "espanyol",
  "settings.statusBarWidget": "Widget de la barra d'estat",
  "settings.statusBarWidgetDescription": "Dades meteorològiques sempre visibles",
  "settings.subscriptionSection": "Subscripció",
  "settings.supportSection": "Assistència",
  "settings.swedish": "suec",
  "settings.systemTheme": "Tema del sistema",
  "settings.termsOfService": "Condicions del servei",
  "settings.turkish": "turc",
  "settings.ukrainian": "ucraïnès",
  "settings.units": "Unitats",
  "settings.unitsDescription": "Unitats de mesura mostrades dins de l'aplicació",
  "settings.update": "Actualitza",
  "settings.windDirectionConvention": "Fletxa de direcció del vent",
  "settings.windDirectionConventionDescription": "Trieu com es mostren les fletxes de direcció del vent",
  "settings.windDirectionMeteorological": "Direcció d'origen",
  "settings.windDirectionMeteorologicalDescription": "La fletxa apunta d'on ve el vent (convenció meteorològica)",
  "settings.windDirectionOceanographic": "Direcció del flux",
  "settings.windDirectionOceanographicDescription": "La fletxa apunta cap on bufa el vent (convenció oceanogràfica)",
  "stations.addAStation": "Afegeix una estació",
  "stations.addToFavorites": "Afegeix als preferits",
  "stations.addYourOwnStation": "Afegeix la vostra pròpia estació",
  "stations.clearRecentLocations": "Esborra-ho tot",
  "stations.clearSearch": "Esborra la cerca",
  "stations.currentLocation": "Ubicació actual",
  "stations.customizedStationName": "Nom personalitzat de l'estació",
  "stations.favoriteLocations": "Preferits",
  "stations.favoriteLocationsEmpty": "Podeu afegir fins a 5 ubicacions preferides.",
  "stations.favoriteStations": "Estacions preferides",
  "stations.filterStationDescription": "No mostris les estacions amb mesures poc fiables",
  "stations.filterStations": "Filtra les estacions",
  "stations.filterStationSourceDescription": "Seleccioneu els proveïdors d'estacions que voleu mostrar al mapa",
  "stations.findStationsNearYou": "Troba estacions a prop teu",
  "stations.hiddenStations": "Estacions amagades",
  "stations.hiddenStationsDescription": "Podeu tornar a mostrar una estació tocant la icona de l'ull que hi ha al costat.",
  "stations.lastSeen": "vist {time}",
  "stations.location": "Ubicació",
  "stations.locationAddedToFavorites": "Ubicació afegida als preferits",
  "stations.locationNotGranted": "No s'ha concedit el permís d'ubicació. Permeteu l'accés a la vostra ubicació a la configuració del dispositiu.",
  "stations.locationRemovedFromFavorites": "Ubicació eliminada dels preferits",
  "stations.locations": "Ubicacions",
  "stations.locationUnavailable": "No s'ha pogut obtenir la vostra ubicació. Comproveu la configuració del dispositiu.",
  "stations.maxFavoriteLocationsReached": "Només podeu tenir fins a 5 ubicacions preferides. Elimineu-ne una per afegir-ne una altra.",
  "stations.modifyFavoriteStations": "Modifica les estacions preferides",
  "stations.modifyFavoriteStationsDescription": "Podeu reordenar les vostres estacions preferides arrossegant-les. També les podeu eliminar de la llista.",
  "stations.myLocation": "La meva ubicació",
  "stations.nearbyWeatherStations": "Estacions meteorològiques properes",
  "stations.noLocationsFound": "No s'ha trobat cap ubicació",
  "stations.noSearchResults": "Cap article coincideix amb la cerca",
  "stations.noStationsFound": "No s'ha trobat cap estació",
  "stations.noWeatherStationYet": "Encara no teniu cap estació meteorològica.",
  "stations.recentLocations": "Recents",
  "stations.recentLocationsEmpty": "El vostre historial recent és buit.",
  "stations.removeFromFavorites": "Elimina dels preferits",
  "stations.searchForLocation": "Cerca una ubicació",
  "stations.searchForWeatherStation": "Cerca una estació meteorològica",
  "stations.searchResults": "Resultats de la cerca",
  "stations.searchResultsEmpty": "No s'ha trobat cap resultat.",
  "stations.searchResultsFound": "{count, plural, one {# resultat trobat} other {# resultats trobats}}",
  "stations.searchStationsDescription": "Introduïu una ciutat, adreça o nom de lloc per trobar estacions meteorològiques properes.",
  "stations.searchStationsHint": "Utilitzeu la barra de cerca de dalt per descobrir estacions meteorològiques a qualsevol ubicació del món.",
  "stations.selectStationForComparison": "Seleccioneu una estació amb què comparar",
  "stations.stationAddedToFavorites": "Estació afegida als preferits",
  "stations.stationCount": "{count, plural, one {# estació} other {# estacions}}",
  "stations.stationInformation": "Informació de l'estació",
  "stations.stationName": "Nom de l'estació",
  "stations.stationObservationsDescription": "Mostra les últimes observacions de les estacions meteorològiques",
  "stations.stationRemovedFromFavorites": "Estació eliminada dels preferits",
  "stations.stationsNear": "Estacions a prop de {place}",
  "stations.stationType": "Tipus d'estació",
  "stations.statusOffline": "Fora de línia",
  "stations.statusOnline": "En línia",
  "stations.statusStale": "Obsolet",
  "stations.tryAnotherLocation": "No hem pogut trobar cap estació meteorològica a prop d'aquesta ubicació. Proveu de cercar una àrea diferent.",
  "stations.weatherStation": "Estació meteorològica",
  "stations.weatherStationCount": "{count, plural, one {# estació meteorològica} other {# estacions meteorològiques}}",
  "stations.weatherStations": "Estacions meteorològiques",
  "stations.welcomeConnectService": "Teniu una estació meteorològica? Connecteu el vostre servei",
  "stations.welcomeSubtitle": "El vostre temps, tot en un sol lloc",
  "thermostat.away": "Fora",
  "thermostat.boilerOn": "Caldera ENCESA",
  "thermostat.hg": "Protecció contra gelades",
  "thermostat.homeInformation": "Informació de la llar",
  "thermostat.homeName": "Nom de la llar",
  "thermostat.manualBoost": "Impuls manual",
  "thermostat.manualSetpointUntil": "Consigna manual fins a",
  "thermostat.noThermostatYet": "Encara no teniu cap termòstat.",
  "thermostat.relay": "Relé",
  "thermostat.room": "Habitació",
  "thermostat.rooms": "Habitacions",
  "thermostat.smartThermostat": "Termòstat intel·ligent",
  "thermostat.smartValve": "Vàlvula intel·ligent",
  "thermostat.whenBackHome": "Quan tornareu a casa?",
  "units.celsius": "Celsius",
  "units.fahrenheit": "Fahrenheit",
  "units.inch": "Polzades",
  "units.inchOfMercury": "Polzades de mercuri",
  "units.kelvin": "Kelvin",
  "units.kilometerPerHour": "Quilòmetres per hora",
  "units.knot": "Nusos",
  "units.meterPerSecond": "Metres per segon",
  "units.milePerHour": "Milles per hora",
  "units.millibar": "Mil·libars",
  "units.millimeter": "Mil·límetres",
  "units.millimeterOfMercury": "Mil·límetres de mercuri",
  "weatherConditions.blizzard": "Tempesta de neu",
  "weatherConditions.blowingDust": "Pols aixecada pel vent",
  "weatherConditions.blowingSnow": "Neu aixecada pel vent",
  "weatherConditions.breezy": "Brisa",
  "weatherConditions.clear": "Serè",
  "weatherConditions.cloudy": "Ennuvolat",
  "weatherConditions.drizzle": "Plugim",
  "weatherConditions.flurries": "Nevada lleugera",
  "weatherConditions.foggy": "Boira",
  "weatherConditions.freezingDrizzle": "Plugim gelant",
  "weatherConditions.freezingRain": "Pluja gelant",
  "weatherConditions.frigid": "Fred glacial",
  "weatherConditions.hail": "Calamarsa",
  "weatherConditions.haze": "Calitja",
  "weatherConditions.heavyRain": "Pluja intensa",
  "weatherConditions.heavySnow": "Nevada intensa",
  "weatherConditions.hot": "Calor",
  "weatherConditions.hurricane": "Huracà",
  "weatherConditions.isolatedThunderstorms": "Tempestes aïllades",
  "weatherConditions.mixedRainAndHail": "Pluja i calamarsa",
  "weatherConditions.mostlyClear": "Majoritàriament serè",
  "weatherConditions.mostlyCloudy": "Majoritàriament ennuvolat",
  "weatherConditions.mostlySunny": "Majoritàriament assolellat",
  "weatherConditions.notAvailable": "Condicions meteorològiques no disponibles",
  "weatherConditions.partlyCloudy": "Parcialment ennuvolat",
  "weatherConditions.rain": "Pluja",
  "weatherConditions.rainSleet": "Pluja i gel granulat",
  "weatherConditions.rainSnow": "Pluja i neu",
  "weatherConditions.scatteredShowers": "Ruixats dispersos",
  "weatherConditions.scatteredSnowShowers": "Ruixats de neu dispersos",
  "weatherConditions.scatteredThunderstorms": "Tempestes disperses",
  "weatherConditions.showers": "Ruixats",
  "weatherConditions.sleet": "Gel granulat",
  "weatherConditions.smoke": "Fum",
  "weatherConditions.snow": "Neu",
  "weatherConditions.snowShowers": "Ruixats de neu",
  "weatherConditions.strongStorms": "Tempestes fortes",
  "weatherConditions.sunny": "Assolellat",
  "weatherConditions.thunderstorms": "Tempestes",
  "weatherConditions.tornado": "Tornado",
  "weatherConditions.tropicalStorm": "Tempesta tropical",
  "weatherConditions.windy": "Ventós",
  "weatherConditions.wintryMix": "Precipitació hivernal mixta",
  "weatherMap.legendHeavy": "Forta",
  "weatherMap.legendLight": "Feble",
  "weatherMap.legendLightningHelp": "El color mostra l'antiguitat de cada llamp durant els últims {minutes} minuts: els més recents en blanc i els més antics en vermell fosc.",
  "weatherMap.legendNewest": "Més recent",
  "weatherMap.legendOldest": "Més antic",
  "weatherMap.legendStationsHelp": "El color del marcador reflecteix el valor de la mètrica seleccionada.",
  "weatherMap.lightningDataAttribution": "Dades de llamps: Blitzortung.org",
  "weatherMap.lightningStrikes": "Llamps",
  "weatherMap.lightningStrikesDescription": "Mostra els llamps en temps real al mapa",
  "weatherMap.mapLayers": "Capes del mapa",
  "weatherMap.mapLegend": "Llegenda del mapa",
  "weatherMap.radarDataAttribution": "Dades del radar: NOAA / EUMETNET OPERA via LibreWXR",
  "weatherMap.rainRadar": "Radar de pluja",
  "weatherMap.rainRadarDescription": "Mostra la superposició del radar de pluja al mapa",
  "weatherMap.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "weatherMap.weatherflowNCRainDescription": "NC Rain és una font de dades addicional proporcionada mitjançant el Tempest Weather System, impulsada per la tecnologia Nearcast. Les dades de NC Rain són una estimació de l'acumulació mitjana de precipitació al voltant del vostre Tempest a escala de barri",
  "weatherMap.weatherMap": "Mapa meteorològic",
  "weatherMap.weatherMapMetaDescription": "SmartMixin ofereix mapes meteorològics i de radar interactius de les condicions meteorològiques per a ubicacions d'arreu del món.",
  "weatherWarnings.activeNow": "Actius ara",
  "weatherWarnings.agencyMessage": "Missatge del servei meteorològic",
  "weatherWarnings.areaCovered": "Zona afectada",
  "weatherWarnings.areaThisLocation": "{area} (aquesta ubicació)",
  "weatherWarnings.areaYourStation": "{area} (la vostra estació meteorològica)",
  "weatherWarnings.crumb": "Avisos oficials",
  "weatherWarnings.emptyBody": "El servei meteorològic nacional no té cap avís vigent per a aquest lloc. Ho tornem a comprovar cada pocs minuts.",
  "weatherWarnings.emptyTitle": "Cap avís oficial",
  "weatherWarnings.ended": "Finalitzat",
  "weatherWarnings.endedAt": "Aquest avís ha finalitzat {time}.",
  "weatherWarnings.errorBody": "Comproveu la connexió. Ho tornem a provar cada pocs minuts.",
  "weatherWarnings.errorTitle": "No s’han pogut carregar els avisos oficials",
  "weatherWarnings.fromTime": "Des de {time}",
  "weatherWarnings.hazardAirQuality": "Qualitat de l'aire",
  "weatherWarnings.hazardAvalanche": "Allaus",
  "weatherWarnings.hazardCoastalEvent": "Fenòmens costaners",
  "weatherWarnings.hazardFlood": "Inundacions",
  "weatherWarnings.hazardFog": "Boira",
  "weatherWarnings.hazardForestFire": "Incendis forestals",
  "weatherWarnings.hazardHighTemperature": "Temperatures altes",
  "weatherWarnings.hazardLowTemperature": "Temperatures baixes",
  "weatherWarnings.hazardOther": "Altre perill",
  "weatherWarnings.hazardRain": "Pluja",
  "weatherWarnings.hazardSnowIce": "Neu i gel",
  "weatherWarnings.hazardThunderstorm": "Tempestes",
  "weatherWarnings.hazardUv": "Radiació UV",
  "weatherWarnings.hazardWind": "Vent",
  "weatherWarnings.hideHazards": "Amaga els fenòmens",
  "weatherWarnings.issuedBy": "Emès per {sender}",
  "weatherWarnings.lastUpdate": "Darrera actualització: {time}",
  "weatherWarnings.mapLabel": "{count, plural, =1 {Mapa de la zona afectada: {area}.} other {Mapa de les # zones afectades. {area} està destacada.}}",
  "weatherWarnings.mapUnavailable": "{count, plural, =1 {Mapa no disponible. La zona apareix a sota.} other {Mapa no disponible. Les # zones apareixen a sota.}}",
  "weatherWarnings.moreHazards": "+ {count} més: {hazards}",
  "weatherWarnings.notInLanguage": "No disponible en {language}. Es mostra tal com l’ha publicat el servei meteorològic.",
  "weatherWarnings.openOn": "Obre a {site}",
  "weatherWarnings.otherAreas": "{count, plural, one {+ # zona més} other {+ # zones més}}",
  "weatherWarnings.severityExtreme": "Extrem",
  "weatherWarnings.severityFrom": "{severity} des de {time}",
  "weatherWarnings.severityMinor": "Lleu",
  "weatherWarnings.severityModerate": "Moderat",
  "weatherWarnings.severityNow": "{severity} ara",
  "weatherWarnings.severitySevere": "Greu",
  "weatherWarnings.severityUntil": "{severity} fins a {time}",
  "weatherWarnings.showAllAreas": "{count, plural, one {Mostra # zona} other {Mostra les # zones}}",
  "weatherWarnings.showHazards": "Mostra els fenòmens",
  "weatherWarnings.showPeriods": "{count, plural, one {Mostra # període} other {Mostra els # períodes}}",
  "weatherWarnings.source": "Font: {source}",
  "weatherWarnings.spokenHazardOne": "{hazard}: {status}.",
  "weatherWarnings.spokenHazardTwo": "{hazard}: {first}, després {second}.",
  "weatherWarnings.spokenLabel": "{count, plural, one {# avís meteorològic oficial} other {# avisos meteorològics oficials}}. {hazards}",
  "weatherWarnings.spokenLabelArea": "{label} {area}.",
  "weatherWarnings.spokenPeriod": "{severity}: {range}",
  "weatherWarnings.title": "Avisos meteorològics oficials",
  "weatherWarnings.todayAt": "avui a les {time}",
  "weatherWarnings.tomorrow": "Demà",
  "weatherWarnings.tomorrowAt": "demà a les {time}",
  "weatherWarnings.upcoming": "Propers",
  "weatherWarnings.viewAll": "Tots els avisos oficials",
  "weatherWarnings.whatToDo": "Què cal fer"
}
